/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
function padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) {
        return input;
    }
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while (padLength--) {
        buffer.write('=', position++);
    }
    return buffer.toString();
}
function toBase64(base64url) {
    base64url = base64url.toString();
    return padString(base64url).replace(/\-/g, '+').replace(/_/g, '/');
}
function base64urlToBuffer(base64url) {
    return Buffer.from(toBase64(base64url), 'base64');
}
function fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64urlEncode(input, encoding) {
    if (encoding === void 0) {
        encoding = 'utf8';
    }
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString('base64'));
    }
    return fromBase64(Buffer.from(input, encoding).toString('base64'));
}
export const aggregateColumnSchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-base-pipe:AggregateColumn',
    type: 'object',
    properties: {
        column: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:ColumnToolVariable' }, { type: 'string' }] },
        operation: {
            oneOf: [
                { $ref: 'urn:wisepipe-base-pipe:EnumToolVariable' },
                {
                    type: 'string',
                    enum: ['MAX', 'MIN', 'COUNT', 'SUM', 'AVG', 'OR', 'AND', 'MEDIAN', 'DIFF', 'PCT', 'SHIFT', 'STDEV']
                }
            ]
        },
        alias: { oneOf: [{ $ref: 'urn:wisepipe-base-pipe:StringToolVariable' }, { type: 'string' }] }
    },
    required: ['operation', 'alias'],
    if: { not: { properties: { operation: { const: 'COUNT' } } } },
    then: { required: ['column'] }
};
const schema30 = { $id: 'urn:wisepipe-base-pipe:ColumnToolVariable', type: 'object', properties: {} };
const schema31 = {
    $id: 'urn:wisepipe-base-pipe:EnumToolVariable',
    type: 'object',
    properties: {
        toolEnumType: {
            type: 'string',
            enum: [
                'SortDirection',
                'AggregateColumnOperation',
                'DateFrequency',
                'DateAddType',
                'DateAddUnit',
                'DateUnitType',
                'DatePartType',
                'JoinOperator',
                'JoinPattern',
                'FilterStatementOp',
                'ColumnType',
                'PeriodAddType'
            ]
        }
    }
};
const schema32 = { $id: 'urn:wisepipe-base-pipe:StringToolVariable', type: 'object', properties: {} };
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:AggregateColumn" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    const _errs3 = errors;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.operation !== undefined) {
            if ('COUNT' !== data.operation) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var valid1 = _errs4 === errors;
    if (valid1) {
        const err1 = {};
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    else {
        errors = _errs3;
        if (vErrors !== null) {
            if (_errs3) {
                vErrors.length = _errs3;
            }
            else {
                vErrors = null;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.column === undefined && (missing0 = 'column')) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs6 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate12.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.operation === undefined && (missing1 = 'operation')) ||
                (data.alias === undefined && (missing1 = 'alias'))) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.column !== undefined) {
                    let data1 = data.column;
                    const _errs7 = errors;
                    const _errs8 = errors;
                    let valid4 = false;
                    let passing0 = null;
                    const _errs9 = errors;
                    const _errs10 = errors;
                    if (errors === _errs10) {
                        if (!(data1 && typeof data1 == 'object' && !Array.isArray(data1))) {
                            const err3 = {
                                instancePath: instancePath + '/column',
                                schemaPath: 'urn:wisepipe-base-pipe:ColumnToolVariable/type',
                                keyword: 'type',
                                params: { type: 'object' },
                                message: 'must be object'
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    var _valid1 = _errs9 === errors;
                    if (_valid1) {
                        valid4 = true;
                        passing0 = 0;
                    }
                    const _errs12 = errors;
                    if (typeof data1 !== 'string') {
                        const err4 = {
                            instancePath: instancePath + '/column',
                            schemaPath: '#/properties/column/oneOf/1/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        };
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                    var _valid1 = _errs12 === errors;
                    if (_valid1 && valid4) {
                        valid4 = false;
                        passing0 = [passing0, 1];
                    }
                    else {
                        if (_valid1) {
                            valid4 = true;
                            passing0 = 1;
                        }
                    }
                    if (!valid4) {
                        const err5 = {
                            instancePath: instancePath + '/column',
                            schemaPath: '#/properties/column/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing0 },
                            message: 'must match exactly one schema in oneOf'
                        };
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                        validate12.errors = vErrors;
                        return false;
                    }
                    else {
                        errors = _errs8;
                        if (vErrors !== null) {
                            if (_errs8) {
                                vErrors.length = _errs8;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                    var valid3 = _errs7 === errors;
                }
                else {
                    var valid3 = true;
                }
                if (valid3) {
                    if (data.operation !== undefined) {
                        let data2 = data.operation;
                        const _errs14 = errors;
                        const _errs15 = errors;
                        let valid6 = false;
                        let passing1 = null;
                        const _errs16 = errors;
                        const _errs17 = errors;
                        if (errors === _errs17) {
                            if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                                if (data2.toolEnumType !== undefined) {
                                    let data3 = data2.toolEnumType;
                                    if (typeof data3 !== 'string') {
                                        const err6 = {
                                            instancePath: instancePath + '/operation/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err6];
                                        }
                                        else {
                                            vErrors.push(err6);
                                        }
                                        errors++;
                                    }
                                    if (!(data3 === 'SortDirection' ||
                                        data3 === 'AggregateColumnOperation' ||
                                        data3 === 'DateFrequency' ||
                                        data3 === 'DateAddType' ||
                                        data3 === 'DateAddUnit' ||
                                        data3 === 'DateUnitType' ||
                                        data3 === 'DatePartType' ||
                                        data3 === 'JoinOperator' ||
                                        data3 === 'JoinPattern' ||
                                        data3 === 'FilterStatementOp' ||
                                        data3 === 'ColumnType' ||
                                        data3 === 'PeriodAddType')) {
                                        const err7 = {
                                            instancePath: instancePath + '/operation/toolEnumType',
                                            schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/properties/toolEnumType/enum',
                                            keyword: 'enum',
                                            params: { allowedValues: schema31.properties.toolEnumType.enum },
                                            message: 'must be equal to one of the allowed values'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            else {
                                const err8 = {
                                    instancePath: instancePath + '/operation',
                                    schemaPath: 'urn:wisepipe-base-pipe:EnumToolVariable/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                        }
                        var _valid2 = _errs16 === errors;
                        if (_valid2) {
                            valid6 = true;
                            passing1 = 0;
                        }
                        const _errs21 = errors;
                        if (typeof data2 !== 'string') {
                            const err9 = {
                                instancePath: instancePath + '/operation',
                                schemaPath: '#/properties/operation/oneOf/1/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                        }
                        if (!(data2 === 'MAX' ||
                            data2 === 'MIN' ||
                            data2 === 'COUNT' ||
                            data2 === 'SUM' ||
                            data2 === 'AVG' ||
                            data2 === 'OR' ||
                            data2 === 'AND' ||
                            data2 === 'MEDIAN' ||
                            data2 === 'DIFF' ||
                            data2 === 'PCT' ||
                            data2 === 'SHIFT' ||
                            data2 === 'STDEV')) {
                            const err10 = {
                                instancePath: instancePath + '/operation',
                                schemaPath: '#/properties/operation/oneOf/1/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema29.properties.operation.oneOf[1].enum },
                                message: 'must be equal to one of the allowed values'
                            };
                            if (vErrors === null) {
                                vErrors = [err10];
                            }
                            else {
                                vErrors.push(err10);
                            }
                            errors++;
                        }
                        var _valid2 = _errs21 === errors;
                        if (_valid2 && valid6) {
                            valid6 = false;
                            passing1 = [passing1, 1];
                        }
                        else {
                            if (_valid2) {
                                valid6 = true;
                                passing1 = 1;
                            }
                        }
                        if (!valid6) {
                            const err11 = {
                                instancePath: instancePath + '/operation',
                                schemaPath: '#/properties/operation/oneOf',
                                keyword: 'oneOf',
                                params: { passingSchemas: passing1 },
                                message: 'must match exactly one schema in oneOf'
                            };
                            if (vErrors === null) {
                                vErrors = [err11];
                            }
                            else {
                                vErrors.push(err11);
                            }
                            errors++;
                            validate12.errors = vErrors;
                            return false;
                        }
                        else {
                            errors = _errs15;
                            if (vErrors !== null) {
                                if (_errs15) {
                                    vErrors.length = _errs15;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                        }
                        var valid3 = _errs14 === errors;
                    }
                    else {
                        var valid3 = true;
                    }
                    if (valid3) {
                        if (data.alias !== undefined) {
                            let data4 = data.alias;
                            const _errs23 = errors;
                            const _errs24 = errors;
                            let valid9 = false;
                            let passing2 = null;
                            const _errs25 = errors;
                            const _errs26 = errors;
                            if (errors === _errs26) {
                                if (!(data4 && typeof data4 == 'object' && !Array.isArray(data4))) {
                                    const err12 = {
                                        instancePath: instancePath + '/alias',
                                        schemaPath: 'urn:wisepipe-base-pipe:StringToolVariable/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err12];
                                    }
                                    else {
                                        vErrors.push(err12);
                                    }
                                    errors++;
                                }
                            }
                            var _valid3 = _errs25 === errors;
                            if (_valid3) {
                                valid9 = true;
                                passing2 = 0;
                            }
                            const _errs28 = errors;
                            if (typeof data4 !== 'string') {
                                const err13 = {
                                    instancePath: instancePath + '/alias',
                                    schemaPath: '#/properties/alias/oneOf/1/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                };
                                if (vErrors === null) {
                                    vErrors = [err13];
                                }
                                else {
                                    vErrors.push(err13);
                                }
                                errors++;
                            }
                            var _valid3 = _errs28 === errors;
                            if (_valid3 && valid9) {
                                valid9 = false;
                                passing2 = [passing2, 1];
                            }
                            else {
                                if (_valid3) {
                                    valid9 = true;
                                    passing2 = 1;
                                }
                            }
                            if (!valid9) {
                                const err14 = {
                                    instancePath: instancePath + '/alias',
                                    schemaPath: '#/properties/alias/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing2 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                                validate12.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs24;
                                if (vErrors !== null) {
                                    if (_errs24) {
                                        vErrors.length = _errs24;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid3 = _errs23 === errors;
                        }
                        else {
                            var valid3 = true;
                        }
                    }
                }
            }
        }
        else {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const boolReusableLogicParameterDefinitionSchemaValidation = validate13;
const schema33 = {
    $id: 'urn:wisepipe-base-pipe:BoolReusableLogicParameterDefinition',
    type: 'object',
    properties: { defaultValue: { type: 'boolean' } },
    required: ['defaultValue']
};
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:BoolReusableLogicParameterDefinition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.defaultValue === undefined && (missing0 = 'defaultValue')) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.defaultValue !== undefined) {
                    if (typeof data.defaultValue !== 'boolean') {
                        validate13.errors = [
                            {
                                instancePath: instancePath + '/defaultValue',
                                schemaPath: '#/properties/defaultValue/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const boolToolParameterSchemaValidation = validate14;
const schema34 = {
    $id: 'urn:wisepipe-base-pipe:BoolToolParameter',
    type: 'object',
    properties: { boolVal: { type: 'boolean' } },
    required: ['boolVal']
};
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:BoolToolParameter" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.boolVal === undefined && (missing0 = 'boolVal')) {
                validate14.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.boolVal !== undefined) {
                    if (typeof data.boolVal !== 'boolean') {
                        validate14.errors = [
                            {
                                instancePath: instancePath + '/boolVal',
                                schemaPath: '#/properties/boolVal/type',
                                keyword: 'type',
                                params: { type: 'boolean' },
                                message: 'must be boolean'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate14.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate14.errors = vErrors;
    return errors === 0;
}
export const boolToolVariableSchemaValidation = validate15;
const schema35 = { $id: 'urn:wisepipe-base-pipe:BoolToolVariable', type: 'object', properties: {} };
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:BoolToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate15.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate15.errors = vErrors;
    return errors === 0;
}
export const calendarReusableLogicParameterDefinitionSchemaValidation = validate16;
const schema36 = {
    $id: 'urn:wisepipe-base-pipe:CalendarReusableLogicParameterDefinition',
    type: 'object',
    properties: { defaultCalendarID: { type: 'string', minLength: 1 }, defaultLevel: { type: 'string', minLength: 1 } },
    required: ['defaultCalendarID', 'defaultLevel']
};
const func2 = ucs2length;
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:CalendarReusableLogicParameterDefinition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.defaultCalendarID === undefined && (missing0 = 'defaultCalendarID')) ||
                (data.defaultLevel === undefined && (missing0 = 'defaultLevel'))) {
                validate16.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.defaultCalendarID !== undefined) {
                    let data0 = data.defaultCalendarID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/defaultCalendarID',
                                        schemaPath: '#/properties/defaultCalendarID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate16.errors = [
                                {
                                    instancePath: instancePath + '/defaultCalendarID',
                                    schemaPath: '#/properties/defaultCalendarID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.defaultLevel !== undefined) {
                        let data1 = data.defaultLevel;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/defaultLevel',
                                            schemaPath: '#/properties/defaultLevel/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/defaultLevel',
                                        schemaPath: '#/properties/defaultLevel/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const calendarToolParameterSchemaValidation = validate17;
const schema37 = {
    $id: 'urn:wisepipe-base-pipe:CalendarToolParameter',
    type: 'object',
    properties: { calendarID: { type: 'string', minLength: 1 }, level: { type: 'string', minLength: 1 } },
    required: ['calendarID', 'level']
};
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:CalendarToolParameter" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.calendarID === undefined && (missing0 = 'calendarID')) ||
                (data.level === undefined && (missing0 = 'level'))) {
                validate17.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.calendarID !== undefined) {
                    let data0 = data.calendarID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/calendarID',
                                        schemaPath: '#/properties/calendarID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/calendarID',
                                    schemaPath: '#/properties/calendarID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.level !== undefined) {
                        let data1 = data.level;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/level',
                                            schemaPath: '#/properties/level/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/level',
                                        schemaPath: '#/properties/level/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const calendarToolVariableSchemaValidation = validate18;
const schema38 = { $id: 'urn:wisepipe-base-pipe:CalendarToolVariable', type: 'object', properties: {} };
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:CalendarToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate18.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
export const challengeDataSchemaValidation = validate19;
const schema39 = {
    $id: 'urn:wisepipe-base-pipe:ChallengeData',
    type: 'object',
    properties: {
        challengeID: { type: 'number', minimum: 1 },
        userID: { type: 'string', minLength: 1, maxLength: 128 },
        dataSourceID: { type: 'string', uid: 9 },
        originID: { type: 'string', uid: 9 },
        createdAt: { type: 'string', format: 'date-time' },
        lastUpdatedAt: { type: 'string', format: 'date-time' },
        percentComplete: { type: 'number', minimum: 0, maximum: 100 },
        state: { type: 'string', enum: ['not_started', 'started', 'complete'] }
    },
    required: ['challengeID', 'percentComplete']
};
const func8 = ucs2length;
const func9 = base64urlToBuffer;
const func10 = base64urlEncode;
const func11 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func12 = ucs2length;
const func13 = base64urlToBuffer;
const func14 = base64urlEncode;
const func15 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const formats0 = formatWrapper['date-time'];
function validate19(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ChallengeData" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.challengeID === undefined && (missing0 = 'challengeID')) ||
                (data.percentComplete === undefined && (missing0 = 'percentComplete'))) {
                validate19.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.challengeID !== undefined) {
                    let data0 = data.challengeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 == 'number') {
                            if (data0 < 1 || isNaN(data0)) {
                                validate19.errors = [
                                    {
                                        instancePath: instancePath + '/challengeID',
                                        schemaPath: '#/properties/challengeID/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: 1 },
                                        message: 'must be >= 1'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate19.errors = [
                                {
                                    instancePath: instancePath + '/challengeID',
                                    schemaPath: '#/properties/challengeID/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.userID !== undefined) {
                        let data1 = data.userID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 128) {
                                    validate19.errors = [
                                        {
                                            instancePath: instancePath + '/userID',
                                            schemaPath: '#/properties/userID/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 128 },
                                            message: 'must NOT have more than 128 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate19.errors = [
                                            {
                                                instancePath: instancePath + '/userID',
                                                schemaPath: '#/properties/userID/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate19.errors = [
                                    {
                                        instancePath: instancePath + '/userID',
                                        schemaPath: '#/properties/userID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.dataSourceID !== undefined) {
                            let data2 = data.dataSourceID;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    const b64min0 = Math.ceil((4 * 9) / 3);
                                    const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                    if (func8(data2) < b64min0 || func8(data2) > b64max0) {
                                        validate19.errors = [
                                            {
                                                instancePath: instancePath + '/dataSourceID',
                                                schemaPath: '#/properties/dataSourceID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func8(data2) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func8(data2)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func9(data2);
                                        if (decoded0.length !== 9) {
                                            validate19.errors = [
                                                {
                                                    instancePath: instancePath + '/dataSourceID',
                                                    schemaPath: '#/properties/dataSourceID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func10(decoded0);
                                            if (func11(encoded0) !== func11(data2)) {
                                                validate19.errors = [
                                                    {
                                                        instancePath: instancePath + '/dataSourceID',
                                                        schemaPath: '#/properties/dataSourceID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate19.errors = [
                                        {
                                            instancePath: instancePath + '/dataSourceID',
                                            schemaPath: '#/properties/dataSourceID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.originID !== undefined) {
                                let data3 = data.originID;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (typeof data3 === 'string') {
                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func12(data3) < b64min1 || func12(data3) > b64max1) {
                                            validate19.errors = [
                                                {
                                                    instancePath: instancePath + '/originID',
                                                    schemaPath: '#/properties/originID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func12(data3) },
                                                    message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func12(data3)
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const decoded1 = func13(data3);
                                            if (decoded1.length !== 9) {
                                                validate19.errors = [
                                                    {
                                                        instancePath: instancePath + '/originID',
                                                        schemaPath: '#/properties/originID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'decoded' },
                                                        message: 'must decode to 9 bytes'
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const encoded1 = func14(decoded1);
                                                if (func15(encoded1) !== func15(data3)) {
                                                    validate19.errors = [
                                                        {
                                                            instancePath: instancePath + '/originID',
                                                            schemaPath: '#/properties/originID/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'ambiguous' },
                                                            message: 'encoding is ambiguous'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate19.errors = [
                                            {
                                                instancePath: instancePath + '/originID',
                                                schemaPath: '#/properties/originID/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.createdAt !== undefined) {
                                    let data4 = data.createdAt;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (errors === _errs9) {
                                            if (typeof data4 === 'string') {
                                                if (!formats0.validate(data4)) {
                                                    validate19.errors = [
                                                        {
                                                            instancePath: instancePath + '/createdAt',
                                                            schemaPath: '#/properties/createdAt/format',
                                                            keyword: 'format',
                                                            params: { format: 'date-time' },
                                                            message: 'must match format "' + 'date-time' + '"'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate19.errors = [
                                                    {
                                                        instancePath: instancePath + '/createdAt',
                                                        schemaPath: '#/properties/createdAt/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.lastUpdatedAt !== undefined) {
                                        let data5 = data.lastUpdatedAt;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (errors === _errs11) {
                                                if (typeof data5 === 'string') {
                                                    if (!formats0.validate(data5)) {
                                                        validate19.errors = [
                                                            {
                                                                instancePath: instancePath + '/lastUpdatedAt',
                                                                schemaPath: '#/properties/lastUpdatedAt/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate19.errors = [
                                                        {
                                                            instancePath: instancePath + '/lastUpdatedAt',
                                                            schemaPath: '#/properties/lastUpdatedAt/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.percentComplete !== undefined) {
                                            let data6 = data.percentComplete;
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (typeof data6 == 'number') {
                                                    if (data6 > 100 || isNaN(data6)) {
                                                        validate19.errors = [
                                                            {
                                                                instancePath: instancePath + '/percentComplete',
                                                                schemaPath: '#/properties/percentComplete/maximum',
                                                                keyword: 'maximum',
                                                                params: { comparison: '<=', limit: 100 },
                                                                message: 'must be <= 100'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                    else {
                                                        if (data6 < 0 || isNaN(data6)) {
                                                            validate19.errors = [
                                                                {
                                                                    instancePath: instancePath + '/percentComplete',
                                                                    schemaPath: '#/properties/percentComplete/minimum',
                                                                    keyword: 'minimum',
                                                                    params: { comparison: '>=', limit: 0 },
                                                                    message: 'must be >= 0'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate19.errors = [
                                                        {
                                                            instancePath: instancePath + '/percentComplete',
                                                            schemaPath: '#/properties/percentComplete/type',
                                                            keyword: 'type',
                                                            params: { type: 'number' },
                                                            message: 'must be number'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs13 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.state !== undefined) {
                                                let data7 = data.state;
                                                const _errs15 = errors;
                                                if (typeof data7 !== 'string') {
                                                    validate19.errors = [
                                                        {
                                                            instancePath: instancePath + '/state',
                                                            schemaPath: '#/properties/state/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                if (!(data7 === 'not_started' || data7 === 'started' || data7 === 'complete')) {
                                                    validate19.errors = [
                                                        {
                                                            instancePath: instancePath + '/state',
                                                            schemaPath: '#/properties/state/enum',
                                                            keyword: 'enum',
                                                            params: { allowedValues: schema39.properties.state.enum },
                                                            message: 'must be equal to one of the allowed values'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs15 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate19.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate19.errors = vErrors;
    return errors === 0;
}
export const columnReusableLogicParameterDefinitionSchemaValidation = validate20;
const schema40 = {
    $id: 'urn:wisepipe-base-pipe:ColumnReusableLogicParameterDefinition',
    type: 'object',
    properties: {
        defaultValue: { type: 'string' },
        columnTypes: {
            type: 'array',
            items: { type: 'string', enum: ['number', 'date', 'string', 'boolean', 'decimal', 'period'] },
            uniqueItems: true
        }
    },
    required: ['columnTypes', 'defaultValue']
};
function validate20(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ColumnReusableLogicParameterDefinition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.columnTypes === undefined && (missing0 = 'columnTypes')) ||
                (data.defaultValue === undefined && (missing0 = 'defaultValue'))) {
                validate20.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.defaultValue !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.defaultValue !== 'string') {
                        validate20.errors = [
                            {
                                instancePath: instancePath + '/defaultValue',
                                schemaPath: '#/properties/defaultValue/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columnTypes !== undefined) {
                        let data1 = data.columnTypes;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    if (typeof data2 !== 'string') {
                                        validate20.errors = [
                                            {
                                                instancePath: instancePath + '/columnTypes/' + i0,
                                                schemaPath: '#/properties/columnTypes/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data2 === 'number' ||
                                        data2 === 'date' ||
                                        data2 === 'string' ||
                                        data2 === 'boolean' ||
                                        data2 === 'decimal' ||
                                        data2 === 'period')) {
                                        validate20.errors = [
                                            {
                                                instancePath: instancePath + '/columnTypes/' + i0,
                                                schemaPath: '#/properties/columnTypes/items/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema40.properties.columnTypes.items.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data1[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate20.errors = [
                                                    {
                                                        instancePath: instancePath + '/columnTypes',
                                                        schemaPath: '#/properties/columnTypes/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                            else {
                                validate20.errors = [
                                    {
                                        instancePath: instancePath + '/columnTypes',
                                        schemaPath: '#/properties/columnTypes/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate20.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate20.errors = vErrors;
    return errors === 0;
}
export const columnToolParameterSchemaValidation = validate21;
const schema41 = {
    $id: 'urn:wisepipe-base-pipe:ColumnToolParameter',
    type: 'object',
    properties: {
        strVal: { type: 'string' },
        columnTypes: {
            type: 'array',
            items: { type: 'string', enum: ['number', 'date', 'string', 'boolean', 'decimal', 'period'] },
            uniqueItems: true
        }
    },
    required: ['strVal', 'columnTypes']
};
function validate21(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ColumnToolParameter" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.strVal === undefined && (missing0 = 'strVal')) ||
                (data.columnTypes === undefined && (missing0 = 'columnTypes'))) {
                validate21.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.strVal !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.strVal !== 'string') {
                        validate21.errors = [
                            {
                                instancePath: instancePath + '/strVal',
                                schemaPath: '#/properties/strVal/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.columnTypes !== undefined) {
                        let data1 = data.columnTypes;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (Array.isArray(data1)) {
                                var valid1 = true;
                                const len0 = data1.length;
                                for (let i0 = 0; i0 < len0; i0++) {
                                    let data2 = data1[i0];
                                    const _errs5 = errors;
                                    if (typeof data2 !== 'string') {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/columnTypes/' + i0,
                                                schemaPath: '#/properties/columnTypes/items/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data2 === 'number' ||
                                        data2 === 'date' ||
                                        data2 === 'string' ||
                                        data2 === 'boolean' ||
                                        data2 === 'decimal' ||
                                        data2 === 'period')) {
                                        validate21.errors = [
                                            {
                                                instancePath: instancePath + '/columnTypes/' + i0,
                                                schemaPath: '#/properties/columnTypes/items/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema41.properties.columnTypes.items.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid1 = _errs5 === errors;
                                    if (!valid1) {
                                        break;
                                    }
                                }
                                if (valid1) {
                                    let i1 = data1.length;
                                    let j0;
                                    if (i1 > 1) {
                                        const indices0 = {};
                                        for (; i1--;) {
                                            let item0 = data1[i1];
                                            if (typeof item0 !== 'string') {
                                                continue;
                                            }
                                            if (typeof indices0[item0] == 'number') {
                                                j0 = indices0[item0];
                                                validate21.errors = [
                                                    {
                                                        instancePath: instancePath + '/columnTypes',
                                                        schemaPath: '#/properties/columnTypes/uniqueItems',
                                                        keyword: 'uniqueItems',
                                                        params: { i: i1, j: j0 },
                                                        message: 'must NOT have duplicate items (items ## ' + j0 + ' and ' + i1 + ' are identical)'
                                                    }
                                                ];
                                                return false;
                                                break;
                                            }
                                            indices0[item0] = i1;
                                        }
                                    }
                                }
                            }
                            else {
                                validate21.errors = [
                                    {
                                        instancePath: instancePath + '/columnTypes',
                                        schemaPath: '#/properties/columnTypes/type',
                                        keyword: 'type',
                                        params: { type: 'array' },
                                        message: 'must be array'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate21.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate21.errors = vErrors;
    return errors === 0;
}
export const columnToolVariableSchemaValidation = validate22;
function validate22(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ColumnToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate22.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate22.errors = vErrors;
    return errors === 0;
}
export const compoundToolVariableSchemaValidation = validate23;
const schema43 = {
    $id: 'urn:wisepipe-base-pipe:CompoundToolVariable',
    type: 'object',
    properties: { value: { type: 'string' } },
    required: ['value']
};
function validate23(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:CompoundToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.value === undefined && (missing0 = 'value')) {
                validate23.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.value !== undefined) {
                    if (typeof data.value !== 'string') {
                        validate23.errors = [
                            {
                                instancePath: instancePath + '/value',
                                schemaPath: '#/properties/value/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate23.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate23.errors = vErrors;
    return errors === 0;
}
export const dateReusableLogicParameterDefinitionSchemaValidation = validate24;
const schema44 = {
    $id: 'urn:wisepipe-base-pipe:DateReusableLogicParameterDefinition',
    type: 'object',
    properties: { defaultValue: { type: 'string', format: 'date-time' } },
    required: ['defaultValue']
};
function validate24(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:DateReusableLogicParameterDefinition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.defaultValue === undefined && (missing0 = 'defaultValue')) {
                validate24.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.defaultValue !== undefined) {
                    let data0 = data.defaultValue;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.validate(data0)) {
                                    validate24.errors = [
                                        {
                                            instancePath: instancePath + '/defaultValue',
                                            schemaPath: '#/properties/defaultValue/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate24.errors = [
                                    {
                                        instancePath: instancePath + '/defaultValue',
                                        schemaPath: '#/properties/defaultValue/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate24.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate24.errors = vErrors;
    return errors === 0;
}
export const dateToolParameterSchemaValidation = validate25;
const schema45 = {
    $id: 'urn:wisepipe-base-pipe:DateToolParameter',
    type: 'object',
    properties: { dateVal: { type: 'string', format: 'date-time' } },
    required: ['dateVal']
};
function validate25(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:DateToolParameter" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.dateVal === undefined && (missing0 = 'dateVal')) {
                validate25.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.dateVal !== undefined) {
                    let data0 = data.dateVal;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.validate(data0)) {
                                    validate25.errors = [
                                        {
                                            instancePath: instancePath + '/dateVal',
                                            schemaPath: '#/properties/dateVal/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate25.errors = [
                                    {
                                        instancePath: instancePath + '/dateVal',
                                        schemaPath: '#/properties/dateVal/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate25.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate25.errors = vErrors;
    return errors === 0;
}
export const dateToolVariableSchemaValidation = validate26;
const schema46 = { $id: 'urn:wisepipe-base-pipe:DateToolVariable', type: 'object', properties: {} };
function validate26(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:DateToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate26.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate26.errors = vErrors;
    return errors === 0;
}
export const elementErrorSchemaValidation = validate27;
const schema47 = {
    $id: 'urn:wisepipe-base-pipe:ElementError',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        elementID: { type: 'string', uid: 10 },
        error: { type: 'string' }
    },
    required: ['pipeID', 'elementID', 'error']
};
const func16 = ucs2length;
const func17 = base64urlToBuffer;
const func18 = base64urlEncode;
const func19 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func20 = ucs2length;
const func21 = base64urlToBuffer;
const func22 = base64urlEncode;
const func23 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate27(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ElementError" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.error === undefined && (missing0 = 'error'))) {
                validate27.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func16(data0) < b64min0 || func16(data0) > b64max0) {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func16(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func16(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func17(data0);
                                if (decoded0.length !== 10) {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func18(decoded0);
                                    if (func19(encoded0) !== func19(data0)) {
                                        validate27.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate27.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.elementID !== undefined) {
                        let data1 = data.elementID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min1 = Math.ceil((4 * 10) / 3);
                                const b64max1 = Math.ceil((4 * 10) / 3) + 3;
                                if (func20(data1) < b64min1 || func20(data1) > b64max1) {
                                    validate27.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func20(data1) },
                                            message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func20(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded1 = func21(data1);
                                    if (decoded1.length !== 10) {
                                        validate27.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded1 = func22(decoded1);
                                        if (func23(encoded1) !== func23(data1)) {
                                            validate27.errors = [
                                                {
                                                    instancePath: instancePath + '/elementID',
                                                    schemaPath: '#/properties/elementID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.error !== undefined) {
                            const _errs5 = errors;
                            if (typeof data.error !== 'string') {
                                validate27.errors = [
                                    {
                                        instancePath: instancePath + '/error',
                                        schemaPath: '#/properties/error/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate27.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate27.errors = vErrors;
    return errors === 0;
}
export const enumReusableLogicParameterDefinitionSchemaValidation = validate28;
const schema48 = {
    $id: 'urn:wisepipe-base-pipe:EnumReusableLogicParameterDefinition',
    type: 'object',
    properties: {
        defaultValue: { type: 'string' },
        toolEnumType: {
            type: 'string',
            enum: [
                'SortDirection',
                'AggregateColumnOperation',
                'DateFrequency',
                'DateAddType',
                'DateAddUnit',
                'DateUnitType',
                'DatePartType',
                'JoinOperator',
                'JoinPattern',
                'FilterStatementOp',
                'ColumnType',
                'PeriodAddType'
            ]
        }
    },
    required: ['toolEnumType', 'defaultValue']
};
function validate28(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:EnumReusableLogicParameterDefinition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.toolEnumType === undefined && (missing0 = 'toolEnumType')) ||
                (data.defaultValue === undefined && (missing0 = 'defaultValue'))) {
                validate28.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.defaultValue !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.defaultValue !== 'string') {
                        validate28.errors = [
                            {
                                instancePath: instancePath + '/defaultValue',
                                schemaPath: '#/properties/defaultValue/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.toolEnumType !== undefined) {
                        let data1 = data.toolEnumType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate28.errors = [
                                {
                                    instancePath: instancePath + '/toolEnumType',
                                    schemaPath: '#/properties/toolEnumType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'SortDirection' ||
                            data1 === 'AggregateColumnOperation' ||
                            data1 === 'DateFrequency' ||
                            data1 === 'DateAddType' ||
                            data1 === 'DateAddUnit' ||
                            data1 === 'DateUnitType' ||
                            data1 === 'DatePartType' ||
                            data1 === 'JoinOperator' ||
                            data1 === 'JoinPattern' ||
                            data1 === 'FilterStatementOp' ||
                            data1 === 'ColumnType' ||
                            data1 === 'PeriodAddType')) {
                            validate28.errors = [
                                {
                                    instancePath: instancePath + '/toolEnumType',
                                    schemaPath: '#/properties/toolEnumType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema48.properties.toolEnumType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate28.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate28.errors = vErrors;
    return errors === 0;
}
export const enumToolParameterSchemaValidation = validate29;
const schema49 = {
    $id: 'urn:wisepipe-base-pipe:EnumToolParameter',
    type: 'object',
    properties: {
        strVal: { type: 'string' },
        toolEnumType: {
            type: 'string',
            enum: [
                'SortDirection',
                'AggregateColumnOperation',
                'DateFrequency',
                'DateAddType',
                'DateAddUnit',
                'DateUnitType',
                'DatePartType',
                'JoinOperator',
                'JoinPattern',
                'FilterStatementOp',
                'ColumnType',
                'PeriodAddType'
            ]
        }
    },
    required: ['strVal', 'toolEnumType']
};
function validate29(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:EnumToolParameter" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.strVal === undefined && (missing0 = 'strVal')) ||
                (data.toolEnumType === undefined && (missing0 = 'toolEnumType'))) {
                validate29.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.strVal !== undefined) {
                    const _errs1 = errors;
                    if (typeof data.strVal !== 'string') {
                        validate29.errors = [
                            {
                                instancePath: instancePath + '/strVal',
                                schemaPath: '#/properties/strVal/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.toolEnumType !== undefined) {
                        let data1 = data.toolEnumType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate29.errors = [
                                {
                                    instancePath: instancePath + '/toolEnumType',
                                    schemaPath: '#/properties/toolEnumType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'SortDirection' ||
                            data1 === 'AggregateColumnOperation' ||
                            data1 === 'DateFrequency' ||
                            data1 === 'DateAddType' ||
                            data1 === 'DateAddUnit' ||
                            data1 === 'DateUnitType' ||
                            data1 === 'DatePartType' ||
                            data1 === 'JoinOperator' ||
                            data1 === 'JoinPattern' ||
                            data1 === 'FilterStatementOp' ||
                            data1 === 'ColumnType' ||
                            data1 === 'PeriodAddType')) {
                            validate29.errors = [
                                {
                                    instancePath: instancePath + '/toolEnumType',
                                    schemaPath: '#/properties/toolEnumType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema49.properties.toolEnumType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate29.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate29.errors = vErrors;
    return errors === 0;
}
export const enumToolVariableSchemaValidation = validate30;
function validate30(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:EnumToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.toolEnumType !== undefined) {
                let data0 = data.toolEnumType;
                if (typeof data0 !== 'string') {
                    validate30.errors = [
                        {
                            instancePath: instancePath + '/toolEnumType',
                            schemaPath: '#/properties/toolEnumType/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                if (!(data0 === 'SortDirection' ||
                    data0 === 'AggregateColumnOperation' ||
                    data0 === 'DateFrequency' ||
                    data0 === 'DateAddType' ||
                    data0 === 'DateAddUnit' ||
                    data0 === 'DateUnitType' ||
                    data0 === 'DatePartType' ||
                    data0 === 'JoinOperator' ||
                    data0 === 'JoinPattern' ||
                    data0 === 'FilterStatementOp' ||
                    data0 === 'ColumnType' ||
                    data0 === 'PeriodAddType')) {
                    validate30.errors = [
                        {
                            instancePath: instancePath + '/toolEnumType',
                            schemaPath: '#/properties/toolEnumType/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema31.properties.toolEnumType.enum },
                            message: 'must be equal to one of the allowed values'
                        }
                    ];
                    return false;
                }
            }
        }
        else {
            validate30.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate30.errors = vErrors;
    return errors === 0;
}
export const numberReusableLogicParameterDefinitionSchemaValidation = validate31;
const schema51 = {
    $id: 'urn:wisepipe-base-pipe:NumberReusableLogicParameterDefinition',
    type: 'object',
    properties: { defaultValue: { type: 'number' } },
    required: ['defaultValue']
};
function validate31(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:NumberReusableLogicParameterDefinition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.defaultValue === undefined && (missing0 = 'defaultValue')) {
                validate31.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.defaultValue !== undefined) {
                    if (!(typeof data.defaultValue == 'number')) {
                        validate31.errors = [
                            {
                                instancePath: instancePath + '/defaultValue',
                                schemaPath: '#/properties/defaultValue/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate31.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate31.errors = vErrors;
    return errors === 0;
}
export const numberToolParameterSchemaValidation = validate32;
const schema52 = {
    $id: 'urn:wisepipe-base-pipe:NumberToolParameter',
    type: 'object',
    properties: { intVal: { type: 'number' } },
    required: ['intVal']
};
function validate32(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:NumberToolParameter" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.intVal === undefined && (missing0 = 'intVal')) {
                validate32.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.intVal !== undefined) {
                    if (!(typeof data.intVal == 'number')) {
                        validate32.errors = [
                            {
                                instancePath: instancePath + '/intVal',
                                schemaPath: '#/properties/intVal/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate32.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate32.errors = vErrors;
    return errors === 0;
}
export const numberToolVariableSchemaValidation = validate33;
const schema53 = { $id: 'urn:wisepipe-base-pipe:NumberToolVariable', type: 'object', properties: {} };
function validate33(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:NumberToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate33.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate33.errors = vErrors;
    return errors === 0;
}
export const pipeDocumentationSchemaValidation = validate34;
const schema54 = {
    $id: 'urn:wisepipe-base-pipe:PipeDocumentation',
    type: 'object',
    properties: {
        lastModified: { type: 'string', format: 'date-time' },
        content: { type: 'string', minLength: 1, maxLength: 50000 }
    },
    required: ['lastModified', 'content']
};
function validate34(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:PipeDocumentation" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.lastModified === undefined && (missing0 = 'lastModified')) ||
                (data.content === undefined && (missing0 = 'content'))) {
                validate34.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.lastModified !== undefined) {
                    let data0 = data.lastModified;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats0.validate(data0)) {
                                    validate34.errors = [
                                        {
                                            instancePath: instancePath + '/lastModified',
                                            schemaPath: '#/properties/lastModified/format',
                                            keyword: 'format',
                                            params: { format: 'date-time' },
                                            message: 'must match format "' + 'date-time' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/lastModified',
                                        schemaPath: '#/properties/lastModified/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.content !== undefined) {
                        let data1 = data.content;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 50000) {
                                    validate34.errors = [
                                        {
                                            instancePath: instancePath + '/content',
                                            schemaPath: '#/properties/content/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 50000 },
                                            message: 'must NOT have more than 50000 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate34.errors = [
                                            {
                                                instancePath: instancePath + '/content',
                                                schemaPath: '#/properties/content/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate34.errors = [
                                    {
                                        instancePath: instancePath + '/content',
                                        schemaPath: '#/properties/content/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate34.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate34.errors = vErrors;
    return errors === 0;
}
export const pipePermissionChangeSchemaValidation = validate35;
const schema55 = {
    $id: 'urn:wisepipe-base-pipe:PipePermissionChange',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        pipeID: { type: 'string', uid: 10 },
        pipePermissionChangeType: { type: 'string', enum: ['set_public', 'set_private', 'add_editor', 'remove_editor'] },
        userIDs: { type: 'array', items: { type: 'string', format: 'uuid' } }
    },
    required: ['orgID', 'pipeID', 'pipePermissionChangeType'],
    if: { properties: { pipePermissionChangeType: { enum: ['add_editor', 'remove_editor'] } } },
    then: { required: ['userIDs'] }
};
const formats10 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
const func26 = ucs2length;
const func27 = base64urlToBuffer;
const func28 = base64urlEncode;
const func29 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate35(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:PipePermissionChange" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.pipePermissionChangeType !== undefined) {
            let data0 = data.pipePermissionChangeType;
            if (!(data0 === 'add_editor' || data0 === 'remove_editor')) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.userIDs === undefined && (missing0 = 'userIDs')) {
                validate35.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate35.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.orgID === undefined && (missing1 = 'orgID')) ||
                (data.pipeID === undefined && (missing1 = 'pipeID')) ||
                (data.pipePermissionChangeType === undefined && (missing1 = 'pipePermissionChangeType'))) {
                validate35.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data1 = data.orgID;
                    const _errs5 = errors;
                    if (errors === _errs5) {
                        if (errors === _errs5) {
                            if (typeof data1 === 'string') {
                                if (!formats10.test(data1)) {
                                    validate35.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate35.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid2 = _errs5 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.pipeID !== undefined) {
                        let data2 = data.pipeID;
                        const _errs7 = errors;
                        if (errors === _errs7) {
                            if (typeof data2 === 'string') {
                                const b64min0 = Math.ceil((4 * 10) / 3);
                                const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                if (func26(data2) < b64min0 || func26(data2) > b64max0) {
                                    validate35.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func26(data2) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func26(data2)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func27(data2);
                                    if (decoded0.length !== 10) {
                                        validate35.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 10 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func28(decoded0);
                                        if (func29(encoded0) !== func29(data2)) {
                                            validate35.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate35.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid2 = _errs7 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.pipePermissionChangeType !== undefined) {
                            let data3 = data.pipePermissionChangeType;
                            const _errs9 = errors;
                            if (typeof data3 !== 'string') {
                                validate35.errors = [
                                    {
                                        instancePath: instancePath + '/pipePermissionChangeType',
                                        schemaPath: '#/properties/pipePermissionChangeType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data3 === 'set_public' ||
                                data3 === 'set_private' ||
                                data3 === 'add_editor' ||
                                data3 === 'remove_editor')) {
                                validate35.errors = [
                                    {
                                        instancePath: instancePath + '/pipePermissionChangeType',
                                        schemaPath: '#/properties/pipePermissionChangeType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema55.properties.pipePermissionChangeType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid2 = _errs9 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.userIDs !== undefined) {
                                let data4 = data.userIDs;
                                const _errs11 = errors;
                                if (errors === _errs11) {
                                    if (Array.isArray(data4)) {
                                        var valid4 = true;
                                        const len0 = data4.length;
                                        for (let i0 = 0; i0 < len0; i0++) {
                                            let data5 = data4[i0];
                                            const _errs13 = errors;
                                            if (errors === _errs13) {
                                                if (errors === _errs13) {
                                                    if (typeof data5 === 'string') {
                                                        if (!formats10.test(data5)) {
                                                            validate35.errors = [
                                                                {
                                                                    instancePath: instancePath + '/userIDs/' + i0,
                                                                    schemaPath: '#/properties/userIDs/items/format',
                                                                    keyword: 'format',
                                                                    params: { format: 'uuid' },
                                                                    message: 'must match format "' + 'uuid' + '"'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate35.errors = [
                                                            {
                                                                instancePath: instancePath + '/userIDs/' + i0,
                                                                schemaPath: '#/properties/userIDs/items/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            var valid4 = _errs13 === errors;
                                            if (!valid4) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate35.errors = [
                                            {
                                                instancePath: instancePath + '/userIDs',
                                                schemaPath: '#/properties/userIDs/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs11 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate35.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate35.errors = vErrors;
    return errors === 0;
}
export const pipeSchemaValidation = validate36;
const schema56 = {
    $id: 'urn:wisepipe-base-pipe:Pipe',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        engineMode: { type: 'string', enum: ['standard', 'big'] },
        createdAt: { type: 'string', format: 'date-time' },
        description: { type: 'string', maxLength: 1000 },
        documentation: { $ref: 'urn:wisepipe-base-pipe:PipeDocumentation' },
        image: { type: 'string', maxLength: 1024 },
        imageUrl: { type: 'string' },
        rowVersion: { type: 'number', minimum: 0 },
        challengeData: { $ref: 'urn:wisepipe-base-pipe:ChallengeData' },
        parentFolderID: { type: 'string', uid: 9 },
        isEditor: { type: 'boolean' },
        isPublic: { type: 'boolean' }
    },
    required: ['pipeID', 'name', 'createdAt', 'engineMode', 'rowVersion']
};
const func30 = ucs2length;
const func31 = base64urlToBuffer;
const func32 = base64urlEncode;
const func33 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func42 = ucs2length;
const func43 = base64urlToBuffer;
const func44 = base64urlEncode;
const func45 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func46 = ucs2length;
const func47 = base64urlToBuffer;
const func48 = base64urlEncode;
const func49 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func50 = ucs2length;
const func51 = base64urlToBuffer;
const func52 = base64urlEncode;
const func53 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate36(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:Pipe" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.createdAt === undefined && (missing0 = 'createdAt')) ||
                (data.engineMode === undefined && (missing0 = 'engineMode')) ||
                (data.rowVersion === undefined && (missing0 = 'rowVersion'))) {
                validate36.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func30(data0) < b64min0 || func30(data0) > b64max0) {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func30(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func30(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func31(data0);
                                if (decoded0.length !== 10) {
                                    validate36.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func32(decoded0);
                                    if (func33(encoded0) !== func33(data0)) {
                                        validate36.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate36.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate36.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate36.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.engineMode !== undefined) {
                            let data2 = data.engineMode;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/engineMode',
                                        schemaPath: '#/properties/engineMode/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'standard' || data2 === 'big')) {
                                validate36.errors = [
                                    {
                                        instancePath: instancePath + '/engineMode',
                                        schemaPath: '#/properties/engineMode/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema56.properties.engineMode.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.createdAt !== undefined) {
                                let data3 = data.createdAt;
                                const _errs7 = errors;
                                if (errors === _errs7) {
                                    if (errors === _errs7) {
                                        if (typeof data3 === 'string') {
                                            if (!formats0.validate(data3)) {
                                                validate36.errors = [
                                                    {
                                                        instancePath: instancePath + '/createdAt',
                                                        schemaPath: '#/properties/createdAt/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate36.errors = [
                                                {
                                                    instancePath: instancePath + '/createdAt',
                                                    schemaPath: '#/properties/createdAt/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.description !== undefined) {
                                    let data4 = data.description;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data4 === 'string') {
                                            if (func2(data4) > 1000) {
                                                validate36.errors = [
                                                    {
                                                        instancePath: instancePath + '/description',
                                                        schemaPath: '#/properties/description/maxLength',
                                                        keyword: 'maxLength',
                                                        params: { limit: 1000 },
                                                        message: 'must NOT have more than 1000 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate36.errors = [
                                                {
                                                    instancePath: instancePath + '/description',
                                                    schemaPath: '#/properties/description/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid0 = _errs9 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.documentation !== undefined) {
                                        let data5 = data.documentation;
                                        const _errs11 = errors;
                                        const _errs12 = errors;
                                        if (errors === _errs12) {
                                            if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                                                let missing1;
                                                if ((data5.lastModified === undefined && (missing1 = 'lastModified')) ||
                                                    (data5.content === undefined && (missing1 = 'content'))) {
                                                    validate36.errors = [
                                                        {
                                                            instancePath: instancePath + '/documentation',
                                                            schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/required',
                                                            keyword: 'required',
                                                            params: { missingProperty: missing1 },
                                                            message: "must have required property '" + missing1 + "'"
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    if (data5.lastModified !== undefined) {
                                                        let data6 = data5.lastModified;
                                                        const _errs14 = errors;
                                                        if (errors === _errs14) {
                                                            if (errors === _errs14) {
                                                                if (typeof data6 === 'string') {
                                                                    if (!formats0.validate(data6)) {
                                                                        validate36.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/documentation/lastModified',
                                                                                schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/lastModified/format',
                                                                                keyword: 'format',
                                                                                params: { format: 'date-time' },
                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                else {
                                                                    validate36.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/documentation/lastModified',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/lastModified/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        var valid3 = _errs14 === errors;
                                                    }
                                                    else {
                                                        var valid3 = true;
                                                    }
                                                    if (valid3) {
                                                        if (data5.content !== undefined) {
                                                            let data7 = data5.content;
                                                            const _errs16 = errors;
                                                            if (errors === _errs16) {
                                                                if (typeof data7 === 'string') {
                                                                    if (func2(data7) > 50000) {
                                                                        validate36.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/documentation/content',
                                                                                schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/content/maxLength',
                                                                                keyword: 'maxLength',
                                                                                params: { limit: 50000 },
                                                                                message: 'must NOT have more than 50000 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        if (func2(data7) < 1) {
                                                                            validate36.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/documentation/content',
                                                                                    schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/content/minLength',
                                                                                    keyword: 'minLength',
                                                                                    params: { limit: 1 },
                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate36.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/documentation/content',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/content/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid3 = _errs16 === errors;
                                                        }
                                                        else {
                                                            var valid3 = true;
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                validate36.errors = [
                                                    {
                                                        instancePath: instancePath + '/documentation',
                                                        schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/type',
                                                        keyword: 'type',
                                                        params: { type: 'object' },
                                                        message: 'must be object'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs11 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.image !== undefined) {
                                            let data8 = data.image;
                                            const _errs18 = errors;
                                            if (errors === _errs18) {
                                                if (typeof data8 === 'string') {
                                                    if (func2(data8) > 1024) {
                                                        validate36.errors = [
                                                            {
                                                                instancePath: instancePath + '/image',
                                                                schemaPath: '#/properties/image/maxLength',
                                                                keyword: 'maxLength',
                                                                params: { limit: 1024 },
                                                                message: 'must NOT have more than 1024 characters'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate36.errors = [
                                                        {
                                                            instancePath: instancePath + '/image',
                                                            schemaPath: '#/properties/image/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid0 = _errs18 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                        if (valid0) {
                                            if (data.imageUrl !== undefined) {
                                                const _errs20 = errors;
                                                if (typeof data.imageUrl !== 'string') {
                                                    validate36.errors = [
                                                        {
                                                            instancePath: instancePath + '/imageUrl',
                                                            schemaPath: '#/properties/imageUrl/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                var valid0 = _errs20 === errors;
                                            }
                                            else {
                                                var valid0 = true;
                                            }
                                            if (valid0) {
                                                if (data.rowVersion !== undefined) {
                                                    let data10 = data.rowVersion;
                                                    const _errs22 = errors;
                                                    if (errors === _errs22) {
                                                        if (typeof data10 == 'number') {
                                                            if (data10 < 0 || isNaN(data10)) {
                                                                validate36.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/rowVersion',
                                                                        schemaPath: '#/properties/rowVersion/minimum',
                                                                        keyword: 'minimum',
                                                                        params: { comparison: '>=', limit: 0 },
                                                                        message: 'must be >= 0'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate36.errors = [
                                                                {
                                                                    instancePath: instancePath + '/rowVersion',
                                                                    schemaPath: '#/properties/rowVersion/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid0 = _errs22 === errors;
                                                }
                                                else {
                                                    var valid0 = true;
                                                }
                                                if (valid0) {
                                                    if (data.challengeData !== undefined) {
                                                        let data11 = data.challengeData;
                                                        const _errs24 = errors;
                                                        const _errs25 = errors;
                                                        if (errors === _errs25) {
                                                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                                                let missing2;
                                                                if ((data11.challengeID === undefined && (missing2 = 'challengeID')) ||
                                                                    (data11.percentComplete === undefined && (missing2 = 'percentComplete'))) {
                                                                    validate36.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/challengeData',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/required',
                                                                            keyword: 'required',
                                                                            params: { missingProperty: missing2 },
                                                                            message: "must have required property '" + missing2 + "'"
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (data11.challengeID !== undefined) {
                                                                        let data12 = data11.challengeID;
                                                                        const _errs27 = errors;
                                                                        if (errors === _errs27) {
                                                                            if (typeof data12 == 'number') {
                                                                                if (data12 < 1 || isNaN(data12)) {
                                                                                    validate36.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/challengeData/challengeID',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/challengeID/minimum',
                                                                                            keyword: 'minimum',
                                                                                            params: { comparison: '>=', limit: 1 },
                                                                                            message: 'must be >= 1'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate36.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/challengeData/challengeID',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/challengeID/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'number' },
                                                                                        message: 'must be number'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid5 = _errs27 === errors;
                                                                    }
                                                                    else {
                                                                        var valid5 = true;
                                                                    }
                                                                    if (valid5) {
                                                                        if (data11.userID !== undefined) {
                                                                            let data13 = data11.userID;
                                                                            const _errs29 = errors;
                                                                            if (errors === _errs29) {
                                                                                if (typeof data13 === 'string') {
                                                                                    if (func2(data13) > 128) {
                                                                                        validate36.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/challengeData/userID',
                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/userID/maxLength',
                                                                                                keyword: 'maxLength',
                                                                                                params: { limit: 128 },
                                                                                                message: 'must NOT have more than 128 characters'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        if (func2(data13) < 1) {
                                                                                            validate36.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/challengeData/userID',
                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/userID/minLength',
                                                                                                    keyword: 'minLength',
                                                                                                    params: { limit: 1 },
                                                                                                    message: 'must NOT have fewer than 1 characters'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate36.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/challengeData/userID',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/userID/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid5 = _errs29 === errors;
                                                                        }
                                                                        else {
                                                                            var valid5 = true;
                                                                        }
                                                                        if (valid5) {
                                                                            if (data11.dataSourceID !== undefined) {
                                                                                let data14 = data11.dataSourceID;
                                                                                const _errs31 = errors;
                                                                                if (errors === _errs31) {
                                                                                    if (typeof data14 === 'string') {
                                                                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                                                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                                                                        if (func42(data14) < b64min1 || func42(data14) > b64max1) {
                                                                                            validate36.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/uid',
                                                                                                    keyword: 'uid',
                                                                                                    params: {
                                                                                                        error: 'encoded',
                                                                                                        b64min: b64min1,
                                                                                                        b64max: b64max1,
                                                                                                        length: func42(data14)
                                                                                                    },
                                                                                                    message: 'length must be between ' +
                                                                                                        b64min1 +
                                                                                                        ' and ' +
                                                                                                        b64max1 +
                                                                                                        ', but is ' +
                                                                                                        func42(data14)
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                        else {
                                                                                            const decoded1 = func43(data14);
                                                                                            if (decoded1.length !== 9) {
                                                                                                validate36.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: { error: 'decoded' },
                                                                                                        message: 'must decode to 9 bytes'
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                const encoded1 = func44(decoded1);
                                                                                                if (func45(encoded1) !== func45(data14)) {
                                                                                                    validate36.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: { error: 'ambiguous' },
                                                                                                            message: 'encoding is ambiguous'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        validate36.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/type',
                                                                                                keyword: 'type',
                                                                                                params: { type: 'string' },
                                                                                                message: 'must be string'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                var valid5 = _errs31 === errors;
                                                                            }
                                                                            else {
                                                                                var valid5 = true;
                                                                            }
                                                                            if (valid5) {
                                                                                if (data11.originID !== undefined) {
                                                                                    let data15 = data11.originID;
                                                                                    const _errs33 = errors;
                                                                                    if (errors === _errs33) {
                                                                                        if (typeof data15 === 'string') {
                                                                                            const b64min2 = Math.ceil((4 * 9) / 3);
                                                                                            const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                                                            if (func46(data15) < b64min2 || func46(data15) > b64max2) {
                                                                                                validate36.errors = [
                                                                                                    {
                                                                                                        instancePath: instancePath + '/challengeData/originID',
                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/uid',
                                                                                                        keyword: 'uid',
                                                                                                        params: {
                                                                                                            error: 'encoded',
                                                                                                            b64min: b64min2,
                                                                                                            b64max: b64max2,
                                                                                                            length: func46(data15)
                                                                                                        },
                                                                                                        message: 'length must be between ' +
                                                                                                            b64min2 +
                                                                                                            ' and ' +
                                                                                                            b64max2 +
                                                                                                            ', but is ' +
                                                                                                            func46(data15)
                                                                                                    }
                                                                                                ];
                                                                                                return false;
                                                                                            }
                                                                                            else {
                                                                                                const decoded2 = func47(data15);
                                                                                                if (decoded2.length !== 9) {
                                                                                                    validate36.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/challengeData/originID',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/uid',
                                                                                                            keyword: 'uid',
                                                                                                            params: { error: 'decoded' },
                                                                                                            message: 'must decode to 9 bytes'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                                else {
                                                                                                    const encoded2 = func48(decoded2);
                                                                                                    if (func49(encoded2) !== func49(data15)) {
                                                                                                        validate36.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/originID',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/uid',
                                                                                                                keyword: 'uid',
                                                                                                                params: { error: 'ambiguous' },
                                                                                                                message: 'encoding is ambiguous'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        else {
                                                                                            validate36.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/challengeData/originID',
                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/type',
                                                                                                    keyword: 'type',
                                                                                                    params: { type: 'string' },
                                                                                                    message: 'must be string'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                    var valid5 = _errs33 === errors;
                                                                                }
                                                                                else {
                                                                                    var valid5 = true;
                                                                                }
                                                                                if (valid5) {
                                                                                    if (data11.createdAt !== undefined) {
                                                                                        let data16 = data11.createdAt;
                                                                                        const _errs35 = errors;
                                                                                        if (errors === _errs35) {
                                                                                            if (errors === _errs35) {
                                                                                                if (typeof data16 === 'string') {
                                                                                                    if (!formats0.validate(data16)) {
                                                                                                        validate36.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/createdAt',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/createdAt/format',
                                                                                                                keyword: 'format',
                                                                                                                params: { format: 'date-time' },
                                                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    validate36.errors = [
                                                                                                        {
                                                                                                            instancePath: instancePath + '/challengeData/createdAt',
                                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/createdAt/type',
                                                                                                            keyword: 'type',
                                                                                                            params: { type: 'string' },
                                                                                                            message: 'must be string'
                                                                                                        }
                                                                                                    ];
                                                                                                    return false;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        var valid5 = _errs35 === errors;
                                                                                    }
                                                                                    else {
                                                                                        var valid5 = true;
                                                                                    }
                                                                                    if (valid5) {
                                                                                        if (data11.lastUpdatedAt !== undefined) {
                                                                                            let data17 = data11.lastUpdatedAt;
                                                                                            const _errs37 = errors;
                                                                                            if (errors === _errs37) {
                                                                                                if (errors === _errs37) {
                                                                                                    if (typeof data17 === 'string') {
                                                                                                        if (!formats0.validate(data17)) {
                                                                                                            validate36.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/challengeData/lastUpdatedAt',
                                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/lastUpdatedAt/format',
                                                                                                                    keyword: 'format',
                                                                                                                    params: { format: 'date-time' },
                                                                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate36.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/lastUpdatedAt',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/lastUpdatedAt/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            var valid5 = _errs37 === errors;
                                                                                        }
                                                                                        else {
                                                                                            var valid5 = true;
                                                                                        }
                                                                                        if (valid5) {
                                                                                            if (data11.percentComplete !== undefined) {
                                                                                                let data18 = data11.percentComplete;
                                                                                                const _errs39 = errors;
                                                                                                if (errors === _errs39) {
                                                                                                    if (typeof data18 == 'number') {
                                                                                                        if (data18 > 100 || isNaN(data18)) {
                                                                                                            validate36.errors = [
                                                                                                                {
                                                                                                                    instancePath: instancePath + '/challengeData/percentComplete',
                                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/percentComplete/maximum',
                                                                                                                    keyword: 'maximum',
                                                                                                                    params: { comparison: '<=', limit: 100 },
                                                                                                                    message: 'must be <= 100'
                                                                                                                }
                                                                                                            ];
                                                                                                            return false;
                                                                                                        }
                                                                                                        else {
                                                                                                            if (data18 < 0 || isNaN(data18)) {
                                                                                                                validate36.errors = [
                                                                                                                    {
                                                                                                                        instancePath: instancePath + '/challengeData/percentComplete',
                                                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/percentComplete/minimum',
                                                                                                                        keyword: 'minimum',
                                                                                                                        params: { comparison: '>=', limit: 0 },
                                                                                                                        message: 'must be >= 0'
                                                                                                                    }
                                                                                                                ];
                                                                                                                return false;
                                                                                                            }
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        validate36.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/percentComplete',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/percentComplete/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'number' },
                                                                                                                message: 'must be number'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                }
                                                                                                var valid5 = _errs39 === errors;
                                                                                            }
                                                                                            else {
                                                                                                var valid5 = true;
                                                                                            }
                                                                                            if (valid5) {
                                                                                                if (data11.state !== undefined) {
                                                                                                    let data19 = data11.state;
                                                                                                    const _errs41 = errors;
                                                                                                    if (typeof data19 !== 'string') {
                                                                                                        validate36.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/state',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/state/type',
                                                                                                                keyword: 'type',
                                                                                                                params: { type: 'string' },
                                                                                                                message: 'must be string'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    if (!(data19 === 'not_started' ||
                                                                                                        data19 === 'started' ||
                                                                                                        data19 === 'complete')) {
                                                                                                        validate36.errors = [
                                                                                                            {
                                                                                                                instancePath: instancePath + '/challengeData/state',
                                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/state/enum',
                                                                                                                keyword: 'enum',
                                                                                                                params: { allowedValues: schema39.properties.state.enum },
                                                                                                                message: 'must be equal to one of the allowed values'
                                                                                                            }
                                                                                                        ];
                                                                                                        return false;
                                                                                                    }
                                                                                                    var valid5 = _errs41 === errors;
                                                                                                }
                                                                                                else {
                                                                                                    var valid5 = true;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate36.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/challengeData',
                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid0 = _errs24 === errors;
                                                    }
                                                    else {
                                                        var valid0 = true;
                                                    }
                                                    if (valid0) {
                                                        if (data.parentFolderID !== undefined) {
                                                            let data20 = data.parentFolderID;
                                                            const _errs43 = errors;
                                                            if (errors === _errs43) {
                                                                if (typeof data20 === 'string') {
                                                                    const b64min3 = Math.ceil((4 * 9) / 3);
                                                                    const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                                    if (func50(data20) < b64min3 || func50(data20) > b64max3) {
                                                                        validate36.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/parentFolderID',
                                                                                schemaPath: '#/properties/parentFolderID/uid',
                                                                                keyword: 'uid',
                                                                                params: {
                                                                                    error: 'encoded',
                                                                                    b64min: b64min3,
                                                                                    b64max: b64max3,
                                                                                    length: func50(data20)
                                                                                },
                                                                                message: 'length must be between ' +
                                                                                    b64min3 +
                                                                                    ' and ' +
                                                                                    b64max3 +
                                                                                    ', but is ' +
                                                                                    func50(data20)
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const decoded3 = func51(data20);
                                                                        if (decoded3.length !== 9) {
                                                                            validate36.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/parentFolderID',
                                                                                    schemaPath: '#/properties/parentFolderID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'decoded' },
                                                                                    message: 'must decode to 9 bytes'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            const encoded3 = func52(decoded3);
                                                                            if (func53(encoded3) !== func53(data20)) {
                                                                                validate36.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/parentFolderID',
                                                                                        schemaPath: '#/properties/parentFolderID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: { error: 'ambiguous' },
                                                                                        message: 'encoding is ambiguous'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate36.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/parentFolderID',
                                                                            schemaPath: '#/properties/parentFolderID/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid0 = _errs43 === errors;
                                                        }
                                                        else {
                                                            var valid0 = true;
                                                        }
                                                        if (valid0) {
                                                            if (data.isEditor !== undefined) {
                                                                const _errs45 = errors;
                                                                if (typeof data.isEditor !== 'boolean') {
                                                                    validate36.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/isEditor',
                                                                            schemaPath: '#/properties/isEditor/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'boolean' },
                                                                            message: 'must be boolean'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                var valid0 = _errs45 === errors;
                                                            }
                                                            else {
                                                                var valid0 = true;
                                                            }
                                                            if (valid0) {
                                                                if (data.isPublic !== undefined) {
                                                                    const _errs47 = errors;
                                                                    if (typeof data.isPublic !== 'boolean') {
                                                                        validate36.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/isPublic',
                                                                                schemaPath: '#/properties/isPublic/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'boolean' },
                                                                                message: 'must be boolean'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    var valid0 = _errs47 === errors;
                                                                }
                                                                else {
                                                                    var valid0 = true;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate36.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate36.errors = vErrors;
    return errors === 0;
}
export const pipeUpdateRequestSchemaValidation = validate37;
const schema59 = {
    $id: 'urn:wisepipe-base-pipe:PipeUpdateRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        image: { type: 'string', maxLength: 1024 },
        parentFolderID: {
            oneOf: [
                { type: 'string', uid: 9 },
                { type: 'string', minLength: 0, maxLength: 0 }
            ]
        },
        challengeData: { $ref: 'urn:wisepipe-base-pipe:ChallengeData' },
        rowVersion: { type: 'number', minimum: 0 }
    },
    required: ['pipeID'],
    if: { anyOf: [{ required: ['parentFolderID'] }, { required: ['challengeData'] }] },
    then: { required: ['rowVersion'] }
};
const func54 = ucs2length;
const func55 = base64urlToBuffer;
const func56 = base64urlEncode;
const func57 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func61 = ucs2length;
const func62 = base64urlToBuffer;
const func63 = base64urlEncode;
const func64 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func69 = ucs2length;
const func70 = base64urlToBuffer;
const func71 = base64urlEncode;
const func72 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const func73 = ucs2length;
const func74 = base64urlToBuffer;
const func75 = base64urlEncode;
const func76 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate37(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:PipeUpdateRequest" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    const _errs3 = errors;
    let valid1 = false;
    const _errs4 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if (data.parentFolderID === undefined && (missing0 = 'parentFolderID')) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var _valid1 = _errs4 === errors;
    valid1 = valid1 || _valid1;
    if (!valid1) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if (data.challengeData === undefined && (missing1 = 'challengeData')) {
                const err1 = {};
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        var _valid1 = _errs5 === errors;
        valid1 = valid1 || _valid1;
    }
    if (!valid1) {
        const err2 = {};
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
    }
    else {
        errors = _errs3;
        if (vErrors !== null) {
            if (_errs3) {
                vErrors.length = _errs3;
            }
            else {
                vErrors = null;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs6 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing2;
            if (data.rowVersion === undefined && (missing2 = 'rowVersion')) {
                validate37.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing2 },
                        message: "must have required property '" + missing2 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs6 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err3 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err3];
        }
        else {
            vErrors.push(err3);
        }
        errors++;
        validate37.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing3;
            if (data.pipeID === undefined && (missing3 = 'pipeID')) {
                validate37.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing3 },
                        message: "must have required property '" + missing3 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.pipeID !== undefined) {
                    let data0 = data.pipeID;
                    const _errs7 = errors;
                    if (errors === _errs7) {
                        if (typeof data0 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func54(data0) < b64min0 || func54(data0) > b64max0) {
                                validate37.errors = [
                                    {
                                        instancePath: instancePath + '/pipeID',
                                        schemaPath: '#/properties/pipeID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func54(data0) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func54(data0)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func55(data0);
                                if (decoded0.length !== 10) {
                                    validate37.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func56(decoded0);
                                    if (func57(encoded0) !== func57(data0)) {
                                        validate37.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate37.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid2 = _errs7 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.name !== undefined) {
                        let data1 = data.name;
                        const _errs9 = errors;
                        if (errors === _errs9) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 100) {
                                    validate37.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data1) < 1) {
                                        validate37.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate37.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid2 = _errs9 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.image !== undefined) {
                            let data2 = data.image;
                            const _errs11 = errors;
                            if (errors === _errs11) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 1024) {
                                        validate37.errors = [
                                            {
                                                instancePath: instancePath + '/image',
                                                schemaPath: '#/properties/image/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 1024 },
                                                message: 'must NOT have more than 1024 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                else {
                                    validate37.errors = [
                                        {
                                            instancePath: instancePath + '/image',
                                            schemaPath: '#/properties/image/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs11 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.parentFolderID !== undefined) {
                                let data3 = data.parentFolderID;
                                const _errs13 = errors;
                                const _errs14 = errors;
                                let valid4 = false;
                                let passing0 = null;
                                const _errs15 = errors;
                                if (errors === _errs15) {
                                    if (typeof data3 === 'string') {
                                        const b64min1 = Math.ceil((4 * 9) / 3);
                                        const b64max1 = Math.ceil((4 * 9) / 3) + 3;
                                        if (func61(data3) < b64min1 || func61(data3) > b64max1) {
                                            const err4 = {
                                                instancePath: instancePath + '/parentFolderID',
                                                schemaPath: '#/properties/parentFolderID/oneOf/0/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min1, b64max: b64max1, length: func61(data3) },
                                                message: 'length must be between ' + b64min1 + ' and ' + b64max1 + ', but is ' + func61(data3)
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err4];
                                            }
                                            else {
                                                vErrors.push(err4);
                                            }
                                            errors++;
                                        }
                                        else {
                                            const decoded1 = func62(data3);
                                            if (decoded1.length !== 9) {
                                                const err5 = {
                                                    instancePath: instancePath + '/parentFolderID',
                                                    schemaPath: '#/properties/parentFolderID/oneOf/0/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 9 bytes'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err5];
                                                }
                                                else {
                                                    vErrors.push(err5);
                                                }
                                                errors++;
                                            }
                                            else {
                                                const encoded1 = func63(decoded1);
                                                if (func64(encoded1) !== func64(data3)) {
                                                    const err6 = {
                                                        instancePath: instancePath + '/parentFolderID',
                                                        schemaPath: '#/properties/parentFolderID/oneOf/0/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    };
                                                    if (vErrors === null) {
                                                        vErrors = [err6];
                                                    }
                                                    else {
                                                        vErrors.push(err6);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err7 = {
                                            instancePath: instancePath + '/parentFolderID',
                                            schemaPath: '#/properties/parentFolderID/oneOf/0/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid2 = _errs15 === errors;
                                if (_valid2) {
                                    valid4 = true;
                                    passing0 = 0;
                                }
                                const _errs17 = errors;
                                if (errors === _errs17) {
                                    if (typeof data3 === 'string') {
                                        if (func2(data3) > 0) {
                                            const err8 = {
                                                instancePath: instancePath + '/parentFolderID',
                                                schemaPath: '#/properties/parentFolderID/oneOf/1/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 0 },
                                                message: 'must NOT have more than 0 characters'
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err8];
                                            }
                                            else {
                                                vErrors.push(err8);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (func2(data3) < 0) {
                                                const err9 = {
                                                    instancePath: instancePath + '/parentFolderID',
                                                    schemaPath: '#/properties/parentFolderID/oneOf/1/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 0 },
                                                    message: 'must NOT have fewer than 0 characters'
                                                };
                                                if (vErrors === null) {
                                                    vErrors = [err9];
                                                }
                                                else {
                                                    vErrors.push(err9);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    else {
                                        const err10 = {
                                            instancePath: instancePath + '/parentFolderID',
                                            schemaPath: '#/properties/parentFolderID/oneOf/1/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err10];
                                        }
                                        else {
                                            vErrors.push(err10);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid2 = _errs17 === errors;
                                if (_valid2 && valid4) {
                                    valid4 = false;
                                    passing0 = [passing0, 1];
                                }
                                else {
                                    if (_valid2) {
                                        valid4 = true;
                                        passing0 = 1;
                                    }
                                }
                                if (!valid4) {
                                    const err11 = {
                                        instancePath: instancePath + '/parentFolderID',
                                        schemaPath: '#/properties/parentFolderID/oneOf',
                                        keyword: 'oneOf',
                                        params: { passingSchemas: passing0 },
                                        message: 'must match exactly one schema in oneOf'
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err11];
                                    }
                                    else {
                                        vErrors.push(err11);
                                    }
                                    errors++;
                                    validate37.errors = vErrors;
                                    return false;
                                }
                                else {
                                    errors = _errs14;
                                    if (vErrors !== null) {
                                        if (_errs14) {
                                            vErrors.length = _errs14;
                                        }
                                        else {
                                            vErrors = null;
                                        }
                                    }
                                }
                                var valid2 = _errs13 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.challengeData !== undefined) {
                                    let data4 = data.challengeData;
                                    const _errs19 = errors;
                                    const _errs20 = errors;
                                    if (errors === _errs20) {
                                        if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                                            let missing4;
                                            if ((data4.challengeID === undefined && (missing4 = 'challengeID')) ||
                                                (data4.percentComplete === undefined && (missing4 = 'percentComplete'))) {
                                                validate37.errors = [
                                                    {
                                                        instancePath: instancePath + '/challengeData',
                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/required',
                                                        keyword: 'required',
                                                        params: { missingProperty: missing4 },
                                                        message: "must have required property '" + missing4 + "'"
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                if (data4.challengeID !== undefined) {
                                                    let data5 = data4.challengeID;
                                                    const _errs22 = errors;
                                                    if (errors === _errs22) {
                                                        if (typeof data5 == 'number') {
                                                            if (data5 < 1 || isNaN(data5)) {
                                                                validate37.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/challengeData/challengeID',
                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/challengeID/minimum',
                                                                        keyword: 'minimum',
                                                                        params: { comparison: '>=', limit: 1 },
                                                                        message: 'must be >= 1'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate37.errors = [
                                                                {
                                                                    instancePath: instancePath + '/challengeData/challengeID',
                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/challengeID/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'number' },
                                                                    message: 'must be number'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid7 = _errs22 === errors;
                                                }
                                                else {
                                                    var valid7 = true;
                                                }
                                                if (valid7) {
                                                    if (data4.userID !== undefined) {
                                                        let data6 = data4.userID;
                                                        const _errs24 = errors;
                                                        if (errors === _errs24) {
                                                            if (typeof data6 === 'string') {
                                                                if (func2(data6) > 128) {
                                                                    validate37.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/challengeData/userID',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/userID/maxLength',
                                                                            keyword: 'maxLength',
                                                                            params: { limit: 128 },
                                                                            message: 'must NOT have more than 128 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                                else {
                                                                    if (func2(data6) < 1) {
                                                                        validate37.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/challengeData/userID',
                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/userID/minLength',
                                                                                keyword: 'minLength',
                                                                                params: { limit: 1 },
                                                                                message: 'must NOT have fewer than 1 characters'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                validate37.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/challengeData/userID',
                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/userID/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'string' },
                                                                        message: 'must be string'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        var valid7 = _errs24 === errors;
                                                    }
                                                    else {
                                                        var valid7 = true;
                                                    }
                                                    if (valid7) {
                                                        if (data4.dataSourceID !== undefined) {
                                                            let data7 = data4.dataSourceID;
                                                            const _errs26 = errors;
                                                            if (errors === _errs26) {
                                                                if (typeof data7 === 'string') {
                                                                    const b64min2 = Math.ceil((4 * 9) / 3);
                                                                    const b64max2 = Math.ceil((4 * 9) / 3) + 3;
                                                                    if (func69(data7) < b64min2 || func69(data7) > b64max2) {
                                                                        validate37.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/uid',
                                                                                keyword: 'uid',
                                                                                params: {
                                                                                    error: 'encoded',
                                                                                    b64min: b64min2,
                                                                                    b64max: b64max2,
                                                                                    length: func69(data7)
                                                                                },
                                                                                message: 'length must be between ' +
                                                                                    b64min2 +
                                                                                    ' and ' +
                                                                                    b64max2 +
                                                                                    ', but is ' +
                                                                                    func69(data7)
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                    else {
                                                                        const decoded2 = func70(data7);
                                                                        if (decoded2.length !== 9) {
                                                                            validate37.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: { error: 'decoded' },
                                                                                    message: 'must decode to 9 bytes'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            const encoded2 = func71(decoded2);
                                                                            if (func72(encoded2) !== func72(data7)) {
                                                                                validate37.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/challengeData/dataSourceID',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: { error: 'ambiguous' },
                                                                                        message: 'encoding is ambiguous'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    validate37.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/challengeData/dataSourceID',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/dataSourceID/type',
                                                                            keyword: 'type',
                                                                            params: { type: 'string' },
                                                                            message: 'must be string'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                            var valid7 = _errs26 === errors;
                                                        }
                                                        else {
                                                            var valid7 = true;
                                                        }
                                                        if (valid7) {
                                                            if (data4.originID !== undefined) {
                                                                let data8 = data4.originID;
                                                                const _errs28 = errors;
                                                                if (errors === _errs28) {
                                                                    if (typeof data8 === 'string') {
                                                                        const b64min3 = Math.ceil((4 * 9) / 3);
                                                                        const b64max3 = Math.ceil((4 * 9) / 3) + 3;
                                                                        if (func73(data8) < b64min3 || func73(data8) > b64max3) {
                                                                            validate37.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/challengeData/originID',
                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/uid',
                                                                                    keyword: 'uid',
                                                                                    params: {
                                                                                        error: 'encoded',
                                                                                        b64min: b64min3,
                                                                                        b64max: b64max3,
                                                                                        length: func73(data8)
                                                                                    },
                                                                                    message: 'length must be between ' +
                                                                                        b64min3 +
                                                                                        ' and ' +
                                                                                        b64max3 +
                                                                                        ', but is ' +
                                                                                        func73(data8)
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            const decoded3 = func74(data8);
                                                                            if (decoded3.length !== 9) {
                                                                                validate37.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/challengeData/originID',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/uid',
                                                                                        keyword: 'uid',
                                                                                        params: { error: 'decoded' },
                                                                                        message: 'must decode to 9 bytes'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                const encoded3 = func75(decoded3);
                                                                                if (func76(encoded3) !== func76(data8)) {
                                                                                    validate37.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/challengeData/originID',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/uid',
                                                                                            keyword: 'uid',
                                                                                            params: { error: 'ambiguous' },
                                                                                            message: 'encoding is ambiguous'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        validate37.errors = [
                                                                            {
                                                                                instancePath: instancePath + '/challengeData/originID',
                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/originID/type',
                                                                                keyword: 'type',
                                                                                params: { type: 'string' },
                                                                                message: 'must be string'
                                                                            }
                                                                        ];
                                                                        return false;
                                                                    }
                                                                }
                                                                var valid7 = _errs28 === errors;
                                                            }
                                                            else {
                                                                var valid7 = true;
                                                            }
                                                            if (valid7) {
                                                                if (data4.createdAt !== undefined) {
                                                                    let data9 = data4.createdAt;
                                                                    const _errs30 = errors;
                                                                    if (errors === _errs30) {
                                                                        if (errors === _errs30) {
                                                                            if (typeof data9 === 'string') {
                                                                                if (!formats0.validate(data9)) {
                                                                                    validate37.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/challengeData/createdAt',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/createdAt/format',
                                                                                            keyword: 'format',
                                                                                            params: { format: 'date-time' },
                                                                                            message: 'must match format "' + 'date-time' + '"'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate37.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/challengeData/createdAt',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/createdAt/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                    var valid7 = _errs30 === errors;
                                                                }
                                                                else {
                                                                    var valid7 = true;
                                                                }
                                                                if (valid7) {
                                                                    if (data4.lastUpdatedAt !== undefined) {
                                                                        let data10 = data4.lastUpdatedAt;
                                                                        const _errs32 = errors;
                                                                        if (errors === _errs32) {
                                                                            if (errors === _errs32) {
                                                                                if (typeof data10 === 'string') {
                                                                                    if (!formats0.validate(data10)) {
                                                                                        validate37.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/challengeData/lastUpdatedAt',
                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/lastUpdatedAt/format',
                                                                                                keyword: 'format',
                                                                                                params: { format: 'date-time' },
                                                                                                message: 'must match format "' + 'date-time' + '"'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate37.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/challengeData/lastUpdatedAt',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/lastUpdatedAt/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                        var valid7 = _errs32 === errors;
                                                                    }
                                                                    else {
                                                                        var valid7 = true;
                                                                    }
                                                                    if (valid7) {
                                                                        if (data4.percentComplete !== undefined) {
                                                                            let data11 = data4.percentComplete;
                                                                            const _errs34 = errors;
                                                                            if (errors === _errs34) {
                                                                                if (typeof data11 == 'number') {
                                                                                    if (data11 > 100 || isNaN(data11)) {
                                                                                        validate37.errors = [
                                                                                            {
                                                                                                instancePath: instancePath + '/challengeData/percentComplete',
                                                                                                schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/percentComplete/maximum',
                                                                                                keyword: 'maximum',
                                                                                                params: { comparison: '<=', limit: 100 },
                                                                                                message: 'must be <= 100'
                                                                                            }
                                                                                        ];
                                                                                        return false;
                                                                                    }
                                                                                    else {
                                                                                        if (data11 < 0 || isNaN(data11)) {
                                                                                            validate37.errors = [
                                                                                                {
                                                                                                    instancePath: instancePath + '/challengeData/percentComplete',
                                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/percentComplete/minimum',
                                                                                                    keyword: 'minimum',
                                                                                                    params: { comparison: '>=', limit: 0 },
                                                                                                    message: 'must be >= 0'
                                                                                                }
                                                                                            ];
                                                                                            return false;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    validate37.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/challengeData/percentComplete',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/percentComplete/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'number' },
                                                                                            message: 'must be number'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            var valid7 = _errs34 === errors;
                                                                        }
                                                                        else {
                                                                            var valid7 = true;
                                                                        }
                                                                        if (valid7) {
                                                                            if (data4.state !== undefined) {
                                                                                let data12 = data4.state;
                                                                                const _errs36 = errors;
                                                                                if (typeof data12 !== 'string') {
                                                                                    validate37.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/challengeData/state',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/state/type',
                                                                                            keyword: 'type',
                                                                                            params: { type: 'string' },
                                                                                            message: 'must be string'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                if (!(data12 === 'not_started' || data12 === 'started' || data12 === 'complete')) {
                                                                                    validate37.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/challengeData/state',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/properties/state/enum',
                                                                                            keyword: 'enum',
                                                                                            params: { allowedValues: schema39.properties.state.enum },
                                                                                            message: 'must be equal to one of the allowed values'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                                var valid7 = _errs36 === errors;
                                                                            }
                                                                            else {
                                                                                var valid7 = true;
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate37.errors = [
                                                {
                                                    instancePath: instancePath + '/challengeData',
                                                    schemaPath: 'urn:wisepipe-base-pipe:ChallengeData/type',
                                                    keyword: 'type',
                                                    params: { type: 'object' },
                                                    message: 'must be object'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs19 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.rowVersion !== undefined) {
                                        let data13 = data.rowVersion;
                                        const _errs38 = errors;
                                        if (errors === _errs38) {
                                            if (typeof data13 == 'number') {
                                                if (data13 < 0 || isNaN(data13)) {
                                                    validate37.errors = [
                                                        {
                                                            instancePath: instancePath + '/rowVersion',
                                                            schemaPath: '#/properties/rowVersion/minimum',
                                                            keyword: 'minimum',
                                                            params: { comparison: '>=', limit: 0 },
                                                            message: 'must be >= 0'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate37.errors = [
                                                    {
                                                        instancePath: instancePath + '/rowVersion',
                                                        schemaPath: '#/properties/rowVersion/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs38 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate37.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate37.errors = vErrors;
    return errors === 0;
}
export const reusableLogicParameterDefinitionSchemaValidation = validate38;
const schema61 = {
    $id: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 150 },
        description: { type: 'string', maxLength: 1000 },
        valueType: { type: 'string', enum: ['string', 'number', 'boolean', 'date', 'enum', 'column', 'calendar'] }
    },
    required: ['name', 'valueType']
};
function validate38(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ReusableLogicParameterDefinition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.valueType === undefined && (missing0 = 'valueType'))) {
                validate38.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) > 150) {
                                validate38.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data0) < 1) {
                                    validate38.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate38.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.description !== undefined) {
                        let data1 = data.description;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) > 1000) {
                                    validate38.errors = [
                                        {
                                            instancePath: instancePath + '/description',
                                            schemaPath: '#/properties/description/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 1000 },
                                            message: 'must NOT have more than 1000 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate38.errors = [
                                    {
                                        instancePath: instancePath + '/description',
                                        schemaPath: '#/properties/description/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.valueType !== undefined) {
                            let data2 = data.valueType;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate38.errors = [
                                    {
                                        instancePath: instancePath + '/valueType',
                                        schemaPath: '#/properties/valueType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'string' ||
                                data2 === 'number' ||
                                data2 === 'boolean' ||
                                data2 === 'date' ||
                                data2 === 'enum' ||
                                data2 === 'column' ||
                                data2 === 'calendar')) {
                                validate38.errors = [
                                    {
                                        instancePath: instancePath + '/valueType',
                                        schemaPath: '#/properties/valueType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema61.properties.valueType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate38.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate38.errors = vErrors;
    return errors === 0;
}
export const reusableLogicUpdateRequestSchemaValidation = validate39;
const schema62 = {
    $id: 'urn:wisepipe-base-pipe:ReusableLogicUpdateRequest',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        reusableLogicID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        documentation: { $ref: 'urn:wisepipe-base-pipe:PipeDocumentation' },
        description: { type: 'string' },
        parameters: { type: 'array', items: { $ref: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition' } },
        aiDescription: { type: 'string' }
    },
    required: ['orgID', 'reusableLogicID']
};
const func80 = ucs2length;
const func81 = base64urlToBuffer;
const func82 = base64urlEncode;
const func83 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate39(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ReusableLogicUpdateRequest" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.orgID === undefined && (missing0 = 'orgID')) ||
                (data.reusableLogicID === undefined && (missing0 = 'reusableLogicID'))) {
                validate39.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.orgID !== undefined) {
                    let data0 = data.orgID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (errors === _errs1) {
                            if (typeof data0 === 'string') {
                                if (!formats10.test(data0)) {
                                    validate39.errors = [
                                        {
                                            instancePath: instancePath + '/orgID',
                                            schemaPath: '#/properties/orgID/format',
                                            keyword: 'format',
                                            params: { format: 'uuid' },
                                            message: 'must match format "' + 'uuid' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate39.errors = [
                                    {
                                        instancePath: instancePath + '/orgID',
                                        schemaPath: '#/properties/orgID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.reusableLogicID !== undefined) {
                        let data1 = data.reusableLogicID;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                const b64min0 = Math.ceil((4 * 9) / 3);
                                const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                if (func80(data1) < b64min0 || func80(data1) > b64max0) {
                                    validate39.errors = [
                                        {
                                            instancePath: instancePath + '/reusableLogicID',
                                            schemaPath: '#/properties/reusableLogicID/uid',
                                            keyword: 'uid',
                                            params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func80(data1) },
                                            message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func80(data1)
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const decoded0 = func81(data1);
                                    if (decoded0.length !== 9) {
                                        validate39.errors = [
                                            {
                                                instancePath: instancePath + '/reusableLogicID',
                                                schemaPath: '#/properties/reusableLogicID/uid',
                                                keyword: 'uid',
                                                params: { error: 'decoded' },
                                                message: 'must decode to 9 bytes'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const encoded0 = func82(decoded0);
                                        if (func83(encoded0) !== func83(data1)) {
                                            validate39.errors = [
                                                {
                                                    instancePath: instancePath + '/reusableLogicID',
                                                    schemaPath: '#/properties/reusableLogicID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'ambiguous' },
                                                    message: 'encoding is ambiguous'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                            }
                            else {
                                validate39.errors = [
                                    {
                                        instancePath: instancePath + '/reusableLogicID',
                                        schemaPath: '#/properties/reusableLogicID/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.name !== undefined) {
                            let data2 = data.name;
                            const _errs5 = errors;
                            if (errors === _errs5) {
                                if (typeof data2 === 'string') {
                                    if (func2(data2) > 100) {
                                        validate39.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/maxLength',
                                                keyword: 'maxLength',
                                                params: { limit: 100 },
                                                message: 'must NOT have more than 100 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        if (func2(data2) < 1) {
                                            validate39.errors = [
                                                {
                                                    instancePath: instancePath + '/name',
                                                    schemaPath: '#/properties/name/minLength',
                                                    keyword: 'minLength',
                                                    params: { limit: 1 },
                                                    message: 'must NOT have fewer than 1 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                else {
                                    validate39.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                        if (valid0) {
                            if (data.documentation !== undefined) {
                                let data3 = data.documentation;
                                const _errs7 = errors;
                                const _errs8 = errors;
                                if (errors === _errs8) {
                                    if (data3 && typeof data3 == 'object' && !Array.isArray(data3)) {
                                        let missing1;
                                        if ((data3.lastModified === undefined && (missing1 = 'lastModified')) ||
                                            (data3.content === undefined && (missing1 = 'content'))) {
                                            validate39.errors = [
                                                {
                                                    instancePath: instancePath + '/documentation',
                                                    schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/required',
                                                    keyword: 'required',
                                                    params: { missingProperty: missing1 },
                                                    message: "must have required property '" + missing1 + "'"
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            if (data3.lastModified !== undefined) {
                                                let data4 = data3.lastModified;
                                                const _errs10 = errors;
                                                if (errors === _errs10) {
                                                    if (errors === _errs10) {
                                                        if (typeof data4 === 'string') {
                                                            if (!formats0.validate(data4)) {
                                                                validate39.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/documentation/lastModified',
                                                                        schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/lastModified/format',
                                                                        keyword: 'format',
                                                                        params: { format: 'date-time' },
                                                                        message: 'must match format "' + 'date-time' + '"'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                        }
                                                        else {
                                                            validate39.errors = [
                                                                {
                                                                    instancePath: instancePath + '/documentation/lastModified',
                                                                    schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/lastModified/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                }
                                                var valid3 = _errs10 === errors;
                                            }
                                            else {
                                                var valid3 = true;
                                            }
                                            if (valid3) {
                                                if (data3.content !== undefined) {
                                                    let data5 = data3.content;
                                                    const _errs12 = errors;
                                                    if (errors === _errs12) {
                                                        if (typeof data5 === 'string') {
                                                            if (func2(data5) > 50000) {
                                                                validate39.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/documentation/content',
                                                                        schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/content/maxLength',
                                                                        keyword: 'maxLength',
                                                                        params: { limit: 50000 },
                                                                        message: 'must NOT have more than 50000 characters'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (func2(data5) < 1) {
                                                                    validate39.errors = [
                                                                        {
                                                                            instancePath: instancePath + '/documentation/content',
                                                                            schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/content/minLength',
                                                                            keyword: 'minLength',
                                                                            params: { limit: 1 },
                                                                            message: 'must NOT have fewer than 1 characters'
                                                                        }
                                                                    ];
                                                                    return false;
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate39.errors = [
                                                                {
                                                                    instancePath: instancePath + '/documentation/content',
                                                                    schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/properties/content/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'string' },
                                                                    message: 'must be string'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid3 = _errs12 === errors;
                                                }
                                                else {
                                                    var valid3 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        validate39.errors = [
                                            {
                                                instancePath: instancePath + '/documentation',
                                                schemaPath: 'urn:wisepipe-base-pipe:PipeDocumentation/type',
                                                keyword: 'type',
                                                params: { type: 'object' },
                                                message: 'must be object'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid0 = _errs7 === errors;
                            }
                            else {
                                var valid0 = true;
                            }
                            if (valid0) {
                                if (data.description !== undefined) {
                                    const _errs14 = errors;
                                    if (typeof data.description !== 'string') {
                                        validate39.errors = [
                                            {
                                                instancePath: instancePath + '/description',
                                                schemaPath: '#/properties/description/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid0 = _errs14 === errors;
                                }
                                else {
                                    var valid0 = true;
                                }
                                if (valid0) {
                                    if (data.parameters !== undefined) {
                                        let data7 = data.parameters;
                                        const _errs16 = errors;
                                        if (errors === _errs16) {
                                            if (Array.isArray(data7)) {
                                                var valid4 = true;
                                                const len0 = data7.length;
                                                for (let i0 = 0; i0 < len0; i0++) {
                                                    let data8 = data7[i0];
                                                    const _errs18 = errors;
                                                    const _errs19 = errors;
                                                    if (errors === _errs19) {
                                                        if (data8 && typeof data8 == 'object' && !Array.isArray(data8)) {
                                                            let missing2;
                                                            if ((data8.name === undefined && (missing2 = 'name')) ||
                                                                (data8.valueType === undefined && (missing2 = 'valueType'))) {
                                                                validate39.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/parameters/' + i0,
                                                                        schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/required',
                                                                        keyword: 'required',
                                                                        params: { missingProperty: missing2 },
                                                                        message: "must have required property '" + missing2 + "'"
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            else {
                                                                if (data8.name !== undefined) {
                                                                    let data9 = data8.name;
                                                                    const _errs21 = errors;
                                                                    if (errors === _errs21) {
                                                                        if (typeof data9 === 'string') {
                                                                            if (func2(data9) > 150) {
                                                                                validate39.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/parameters/' + i0 + '/name',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/name/maxLength',
                                                                                        keyword: 'maxLength',
                                                                                        params: { limit: 150 },
                                                                                        message: 'must NOT have more than 150 characters'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            else {
                                                                                if (func2(data9) < 1) {
                                                                                    validate39.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/parameters/' + i0 + '/name',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/name/minLength',
                                                                                            keyword: 'minLength',
                                                                                            params: { limit: 1 },
                                                                                            message: 'must NOT have fewer than 1 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                        }
                                                                        else {
                                                                            validate39.errors = [
                                                                                {
                                                                                    instancePath: instancePath + '/parameters/' + i0 + '/name',
                                                                                    schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/name/type',
                                                                                    keyword: 'type',
                                                                                    params: { type: 'string' },
                                                                                    message: 'must be string'
                                                                                }
                                                                            ];
                                                                            return false;
                                                                        }
                                                                    }
                                                                    var valid6 = _errs21 === errors;
                                                                }
                                                                else {
                                                                    var valid6 = true;
                                                                }
                                                                if (valid6) {
                                                                    if (data8.description !== undefined) {
                                                                        let data10 = data8.description;
                                                                        const _errs23 = errors;
                                                                        if (errors === _errs23) {
                                                                            if (typeof data10 === 'string') {
                                                                                if (func2(data10) > 1000) {
                                                                                    validate39.errors = [
                                                                                        {
                                                                                            instancePath: instancePath + '/parameters/' + i0 + '/description',
                                                                                            schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/description/maxLength',
                                                                                            keyword: 'maxLength',
                                                                                            params: { limit: 1000 },
                                                                                            message: 'must NOT have more than 1000 characters'
                                                                                        }
                                                                                    ];
                                                                                    return false;
                                                                                }
                                                                            }
                                                                            else {
                                                                                validate39.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/parameters/' + i0 + '/description',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/description/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                        }
                                                                        var valid6 = _errs23 === errors;
                                                                    }
                                                                    else {
                                                                        var valid6 = true;
                                                                    }
                                                                    if (valid6) {
                                                                        if (data8.valueType !== undefined) {
                                                                            let data11 = data8.valueType;
                                                                            const _errs25 = errors;
                                                                            if (typeof data11 !== 'string') {
                                                                                validate39.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/parameters/' + i0 + '/valueType',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/valueType/type',
                                                                                        keyword: 'type',
                                                                                        params: { type: 'string' },
                                                                                        message: 'must be string'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            if (!(data11 === 'string' ||
                                                                                data11 === 'number' ||
                                                                                data11 === 'boolean' ||
                                                                                data11 === 'date' ||
                                                                                data11 === 'enum' ||
                                                                                data11 === 'column' ||
                                                                                data11 === 'calendar')) {
                                                                                validate39.errors = [
                                                                                    {
                                                                                        instancePath: instancePath + '/parameters/' + i0 + '/valueType',
                                                                                        schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/properties/valueType/enum',
                                                                                        keyword: 'enum',
                                                                                        params: { allowedValues: schema61.properties.valueType.enum },
                                                                                        message: 'must be equal to one of the allowed values'
                                                                                    }
                                                                                ];
                                                                                return false;
                                                                            }
                                                                            var valid6 = _errs25 === errors;
                                                                        }
                                                                        else {
                                                                            var valid6 = true;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            validate39.errors = [
                                                                {
                                                                    instancePath: instancePath + '/parameters/' + i0,
                                                                    schemaPath: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition/type',
                                                                    keyword: 'type',
                                                                    params: { type: 'object' },
                                                                    message: 'must be object'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    var valid4 = _errs18 === errors;
                                                    if (!valid4) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate39.errors = [
                                                    {
                                                        instancePath: instancePath + '/parameters',
                                                        schemaPath: '#/properties/parameters/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid0 = _errs16 === errors;
                                    }
                                    else {
                                        var valid0 = true;
                                    }
                                    if (valid0) {
                                        if (data.aiDescription !== undefined) {
                                            const _errs27 = errors;
                                            if (typeof data.aiDescription !== 'string') {
                                                validate39.errors = [
                                                    {
                                                        instancePath: instancePath + '/aiDescription',
                                                        schemaPath: '#/properties/aiDescription/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid0 = _errs27 === errors;
                                        }
                                        else {
                                            var valid0 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate39.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate39.errors = vErrors;
    return errors === 0;
}
export const simpleToolVariableSchemaValidation = validate40;
const schema65 = {
    $id: 'urn:wisepipe-base-pipe:SimpleToolVariable',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        expectedValueType: { type: 'string', enum: ['string', 'number', 'boolean', 'date', 'enum', 'column', 'calendar'] },
        parameterType: { type: 'string', enum: ['global', 'pipe', 'calc', 'reusable', 'tool'] }
    },
    required: ['name', 'parameterType']
};
function validate40(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:SimpleToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.parameterType === undefined && (missing0 = 'parameterType'))) {
                validate40.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data0 = data.name;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate40.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate40.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.expectedValueType !== undefined) {
                        let data1 = data.expectedValueType;
                        const _errs3 = errors;
                        if (typeof data1 !== 'string') {
                            validate40.errors = [
                                {
                                    instancePath: instancePath + '/expectedValueType',
                                    schemaPath: '#/properties/expectedValueType/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data1 === 'string' ||
                            data1 === 'number' ||
                            data1 === 'boolean' ||
                            data1 === 'date' ||
                            data1 === 'enum' ||
                            data1 === 'column' ||
                            data1 === 'calendar')) {
                            validate40.errors = [
                                {
                                    instancePath: instancePath + '/expectedValueType',
                                    schemaPath: '#/properties/expectedValueType/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema65.properties.expectedValueType.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                    if (valid0) {
                        if (data.parameterType !== undefined) {
                            let data2 = data.parameterType;
                            const _errs5 = errors;
                            if (typeof data2 !== 'string') {
                                validate40.errors = [
                                    {
                                        instancePath: instancePath + '/parameterType',
                                        schemaPath: '#/properties/parameterType/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data2 === 'global' ||
                                data2 === 'pipe' ||
                                data2 === 'calc' ||
                                data2 === 'reusable' ||
                                data2 === 'tool')) {
                                validate40.errors = [
                                    {
                                        instancePath: instancePath + '/parameterType',
                                        schemaPath: '#/properties/parameterType/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema65.properties.parameterType.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid0 = _errs5 === errors;
                        }
                        else {
                            var valid0 = true;
                        }
                    }
                }
            }
        }
        else {
            validate40.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate40.errors = vErrors;
    return errors === 0;
}
export const stringReusableLogicParameterDefinitionSchemaValidation = validate41;
const schema66 = {
    $id: 'urn:wisepipe-base-pipe:StringReusableLogicParameterDefinition',
    type: 'object',
    properties: { defaultValue: { type: 'string' } },
    required: ['defaultValue']
};
function validate41(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:StringReusableLogicParameterDefinition" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.defaultValue === undefined && (missing0 = 'defaultValue')) {
                validate41.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.defaultValue !== undefined) {
                    if (typeof data.defaultValue !== 'string') {
                        validate41.errors = [
                            {
                                instancePath: instancePath + '/defaultValue',
                                schemaPath: '#/properties/defaultValue/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate41.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate41.errors = vErrors;
    return errors === 0;
}
export const stringToolParameterSchemaValidation = validate42;
const schema67 = {
    $id: 'urn:wisepipe-base-pipe:StringToolParameter',
    type: 'object',
    properties: { strVal: { type: 'string' } },
    required: ['strVal']
};
function validate42(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:StringToolParameter" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.strVal === undefined && (missing0 = 'strVal')) {
                validate42.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.strVal !== undefined) {
                    if (typeof data.strVal !== 'string') {
                        validate42.errors = [
                            {
                                instancePath: instancePath + '/strVal',
                                schemaPath: '#/properties/strVal/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate42.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate42.errors = vErrors;
    return errors === 0;
}
export const stringToolVariableSchemaValidation = validate43;
function validate43(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:StringToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (!(data && typeof data == 'object' && !Array.isArray(data))) {
            validate43.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate43.errors = vErrors;
    return errors === 0;
}
export const toolParameterSchemaValidation = validate44;
const schema69 = {
    $id: 'urn:wisepipe-base-pipe:ToolParameter',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 150 },
        type: { type: 'string', enum: ['global', 'pipe', 'calc', 'reusable', 'tool'] },
        pipeID: { type: 'string', uid: 10 },
        description: { type: 'string', maxLength: 1000 },
        valueType: { type: 'string', enum: ['string', 'number', 'boolean', 'date', 'enum', 'column', 'calendar'] },
        createdAt: { type: 'string', format: 'date-time' },
        updatedAt: { type: 'string', format: 'date-time' }
    },
    required: ['name', 'type', 'pipeID', 'valueType'],
    if: { properties: { type: { const: 'global' } } },
    then: { properties: { pipeID: { type: 'string', const: 'AAAAAAAAAAAAAA' } } },
    else: {
        if: { properties: { type: { const: 'reusable' } } },
        then: { properties: { pipeID: { type: 'string', const: 'BBBBBBBBBBBBBA' } } },
        else: {
            if: { properties: { type: { const: 'tool' } } },
            then: { properties: { pipeID: { type: 'string', const: 'BBBBBBBBBBBBBA' } } }
        }
    }
};
const func94 = ucs2length;
const func95 = base64urlToBuffer;
const func96 = base64urlEncode;
const func97 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate44(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ToolParameter" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type !== undefined) {
            if ('global' !== data.type) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.pipeID !== undefined) {
                let data1 = data.pipeID;
                if (typeof data1 !== 'string') {
                    validate44.errors = [
                        {
                            instancePath: instancePath + '/pipeID',
                            schemaPath: '#/then/properties/pipeID/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string'
                        }
                    ];
                    return false;
                }
                if ('AAAAAAAAAAAAAA' !== data1) {
                    validate44.errors = [
                        {
                            instancePath: instancePath + '/pipeID',
                            schemaPath: '#/then/properties/pipeID/const',
                            keyword: 'const',
                            params: { allowedValue: 'AAAAAAAAAAAAAA' },
                            message: 'must be equal to constant'
                        }
                    ];
                    return false;
                }
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs7 = errors;
        const _errs8 = errors;
        let valid3 = true;
        const _errs9 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.type !== undefined) {
                if ('reusable' !== data.type) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs9 === errors;
        errors = _errs8;
        if (vErrors !== null) {
            if (_errs8) {
                vErrors.length = _errs8;
            }
            else {
                vErrors = null;
            }
        }
        let ifClause1;
        if (_valid1) {
            const _errs11 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.pipeID !== undefined) {
                    let data3 = data.pipeID;
                    if (typeof data3 !== 'string') {
                        validate44.errors = [
                            {
                                instancePath: instancePath + '/pipeID',
                                schemaPath: '#/else/then/properties/pipeID/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if ('BBBBBBBBBBBBBA' !== data3) {
                        validate44.errors = [
                            {
                                instancePath: instancePath + '/pipeID',
                                schemaPath: '#/else/then/properties/pipeID/const',
                                keyword: 'const',
                                params: { allowedValue: 'BBBBBBBBBBBBBA' },
                                message: 'must be equal to constant'
                            }
                        ];
                        return false;
                    }
                }
            }
            var _valid1 = _errs11 === errors;
            valid3 = _valid1;
            ifClause1 = 'then';
        }
        else {
            const _errs14 = errors;
            const _errs15 = errors;
            let valid6 = true;
            const _errs16 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.type !== undefined) {
                    if ('tool' !== data.type) {
                        const err2 = {};
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs16 === errors;
            errors = _errs15;
            if (vErrors !== null) {
                if (_errs15) {
                    vErrors.length = _errs15;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs18 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.pipeID !== undefined) {
                        let data5 = data.pipeID;
                        if (typeof data5 !== 'string') {
                            validate44.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/else/else/then/properties/pipeID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if ('BBBBBBBBBBBBBA' !== data5) {
                            validate44.errors = [
                                {
                                    instancePath: instancePath + '/pipeID',
                                    schemaPath: '#/else/else/then/properties/pipeID/const',
                                    keyword: 'const',
                                    params: { allowedValue: 'BBBBBBBBBBBBBA' },
                                    message: 'must be equal to constant'
                                }
                            ];
                            return false;
                        }
                    }
                }
                var _valid2 = _errs18 === errors;
                valid6 = _valid2;
            }
            if (!valid6) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/else/else/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
                validate44.errors = vErrors;
                return false;
            }
            var _valid1 = _errs14 === errors;
            valid3 = _valid1;
            ifClause1 = 'else';
        }
        if (!valid3) {
            const err4 = {
                instancePath,
                schemaPath: '#/else/if',
                keyword: 'if',
                params: { failingKeyword: ifClause1 },
                message: 'must match "' + ifClause1 + '" schema'
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
            validate44.errors = vErrors;
            return false;
        }
        var _valid0 = _errs7 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate44.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.name === undefined && (missing0 = 'name')) ||
                (data.type === undefined && (missing0 = 'type')) ||
                (data.pipeID === undefined && (missing0 = 'pipeID')) ||
                (data.valueType === undefined && (missing0 = 'valueType'))) {
                validate44.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data6 = data.name;
                    const _errs21 = errors;
                    if (errors === _errs21) {
                        if (typeof data6 === 'string') {
                            if (func2(data6) > 150) {
                                validate44.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data6) < 1) {
                                    validate44.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate44.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid9 = _errs21 === errors;
                }
                else {
                    var valid9 = true;
                }
                if (valid9) {
                    if (data.type !== undefined) {
                        let data7 = data.type;
                        const _errs23 = errors;
                        if (typeof data7 !== 'string') {
                            validate44.errors = [
                                {
                                    instancePath: instancePath + '/type',
                                    schemaPath: '#/properties/type/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                        if (!(data7 === 'global' || data7 === 'pipe' || data7 === 'calc' || data7 === 'reusable' || data7 === 'tool')) {
                            validate44.errors = [
                                {
                                    instancePath: instancePath + '/type',
                                    schemaPath: '#/properties/type/enum',
                                    keyword: 'enum',
                                    params: { allowedValues: schema69.properties.type.enum },
                                    message: 'must be equal to one of the allowed values'
                                }
                            ];
                            return false;
                        }
                        var valid9 = _errs23 === errors;
                    }
                    else {
                        var valid9 = true;
                    }
                    if (valid9) {
                        if (data.pipeID !== undefined) {
                            let data8 = data.pipeID;
                            const _errs25 = errors;
                            if (errors === _errs25) {
                                if (typeof data8 === 'string') {
                                    const b64min0 = Math.ceil((4 * 10) / 3);
                                    const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                                    if (func94(data8) < b64min0 || func94(data8) > b64max0) {
                                        validate44.errors = [
                                            {
                                                instancePath: instancePath + '/pipeID',
                                                schemaPath: '#/properties/pipeID/uid',
                                                keyword: 'uid',
                                                params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func94(data8) },
                                                message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func94(data8)
                                            }
                                        ];
                                        return false;
                                    }
                                    else {
                                        const decoded0 = func95(data8);
                                        if (decoded0.length !== 10) {
                                            validate44.errors = [
                                                {
                                                    instancePath: instancePath + '/pipeID',
                                                    schemaPath: '#/properties/pipeID/uid',
                                                    keyword: 'uid',
                                                    params: { error: 'decoded' },
                                                    message: 'must decode to 10 bytes'
                                                }
                                            ];
                                            return false;
                                        }
                                        else {
                                            const encoded0 = func96(decoded0);
                                            if (func97(encoded0) !== func97(data8)) {
                                                validate44.errors = [
                                                    {
                                                        instancePath: instancePath + '/pipeID',
                                                        schemaPath: '#/properties/pipeID/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'ambiguous' },
                                                        message: 'encoding is ambiguous'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                    }
                                }
                                else {
                                    validate44.errors = [
                                        {
                                            instancePath: instancePath + '/pipeID',
                                            schemaPath: '#/properties/pipeID/type',
                                            keyword: 'type',
                                            params: { type: 'string' },
                                            message: 'must be string'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid9 = _errs25 === errors;
                        }
                        else {
                            var valid9 = true;
                        }
                        if (valid9) {
                            if (data.description !== undefined) {
                                let data9 = data.description;
                                const _errs27 = errors;
                                if (errors === _errs27) {
                                    if (typeof data9 === 'string') {
                                        if (func2(data9) > 1000) {
                                            validate44.errors = [
                                                {
                                                    instancePath: instancePath + '/description',
                                                    schemaPath: '#/properties/description/maxLength',
                                                    keyword: 'maxLength',
                                                    params: { limit: 1000 },
                                                    message: 'must NOT have more than 1000 characters'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    else {
                                        validate44.errors = [
                                            {
                                                instancePath: instancePath + '/description',
                                                schemaPath: '#/properties/description/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid9 = _errs27 === errors;
                            }
                            else {
                                var valid9 = true;
                            }
                            if (valid9) {
                                if (data.valueType !== undefined) {
                                    let data10 = data.valueType;
                                    const _errs29 = errors;
                                    if (typeof data10 !== 'string') {
                                        validate44.errors = [
                                            {
                                                instancePath: instancePath + '/valueType',
                                                schemaPath: '#/properties/valueType/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    if (!(data10 === 'string' ||
                                        data10 === 'number' ||
                                        data10 === 'boolean' ||
                                        data10 === 'date' ||
                                        data10 === 'enum' ||
                                        data10 === 'column' ||
                                        data10 === 'calendar')) {
                                        validate44.errors = [
                                            {
                                                instancePath: instancePath + '/valueType',
                                                schemaPath: '#/properties/valueType/enum',
                                                keyword: 'enum',
                                                params: { allowedValues: schema69.properties.valueType.enum },
                                                message: 'must be equal to one of the allowed values'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid9 = _errs29 === errors;
                                }
                                else {
                                    var valid9 = true;
                                }
                                if (valid9) {
                                    if (data.createdAt !== undefined) {
                                        let data11 = data.createdAt;
                                        const _errs31 = errors;
                                        if (errors === _errs31) {
                                            if (errors === _errs31) {
                                                if (typeof data11 === 'string') {
                                                    if (!formats0.validate(data11)) {
                                                        validate44.errors = [
                                                            {
                                                                instancePath: instancePath + '/createdAt',
                                                                schemaPath: '#/properties/createdAt/format',
                                                                keyword: 'format',
                                                                params: { format: 'date-time' },
                                                                message: 'must match format "' + 'date-time' + '"'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                else {
                                                    validate44.errors = [
                                                        {
                                                            instancePath: instancePath + '/createdAt',
                                                            schemaPath: '#/properties/createdAt/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                        }
                                        var valid9 = _errs31 === errors;
                                    }
                                    else {
                                        var valid9 = true;
                                    }
                                    if (valid9) {
                                        if (data.updatedAt !== undefined) {
                                            let data12 = data.updatedAt;
                                            const _errs33 = errors;
                                            if (errors === _errs33) {
                                                if (errors === _errs33) {
                                                    if (typeof data12 === 'string') {
                                                        if (!formats0.validate(data12)) {
                                                            validate44.errors = [
                                                                {
                                                                    instancePath: instancePath + '/updatedAt',
                                                                    schemaPath: '#/properties/updatedAt/format',
                                                                    keyword: 'format',
                                                                    params: { format: 'date-time' },
                                                                    message: 'must match format "' + 'date-time' + '"'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                    }
                                                    else {
                                                        validate44.errors = [
                                                            {
                                                                instancePath: instancePath + '/updatedAt',
                                                                schemaPath: '#/properties/updatedAt/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                            var valid9 = _errs33 === errors;
                                        }
                                        else {
                                            var valid9 = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate44.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate44.errors = vErrors;
    return errors === 0;
}
export const toolVariableSchemaValidation = validate45;
const schema70 = {
    $id: 'urn:wisepipe-base-pipe:ToolVariable',
    type: 'object',
    properties: {
        type: { type: 'string', enum: ['string', 'column', 'compound', 'number', 'boolean', 'date', 'enum', 'calendar'] }
    },
    required: ['type']
};
function validate45(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-pipe:ToolVariable" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.type === undefined && (missing0 = 'type')) {
                validate45.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.type !== undefined) {
                    let data0 = data.type;
                    if (typeof data0 !== 'string') {
                        validate45.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data0 === 'string' ||
                        data0 === 'column' ||
                        data0 === 'compound' ||
                        data0 === 'number' ||
                        data0 === 'boolean' ||
                        data0 === 'date' ||
                        data0 === 'enum' ||
                        data0 === 'calendar')) {
                        validate45.errors = [
                            {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/properties/type/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema70.properties.type.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                }
            }
        }
        else {
            validate45.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate45.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map